export enum sitePermissions {
  dsStudentDashboard = "Students-dashboard",
  dsStudentAcademicDashboard = "Student-Academic-dashboard",
  academicsDeficientStudentsListing = "academic-deficient-students-list",
  academicsDeficientStudentsRecommend = "academic-deficient-students-recommend",
  academicsDeficientStudentsApprove = "academic-deficient-students-approve",
  academicsDeficientStudentsSync = "academic-deficient-students-sync",
  studentTimetable = "TimeTable-view",
  lectureAttendance = "TimeTable-lecture-attendance",
  timeTableDownloadDailyPdf = "TimeTable-download-daily-pdf",
  scholarshipDashboard = "scholarship-Dashboard",



  organizationSettingView = "organizations-settings-view",
  studentCardManagementTemplate = "student-card-settings-view",
  organizationSettingCreate = "organizations-settings-update",
  organizationPaymentsSettingCreate = "Payments-setting-create",
  organizationPaymentsSettingListing = "Payments-setting-list",
  organizationPaymentsSettingUpdate = "Payments-setting-update",
  forgetPassword = "forget-password",
  codeVerification = "verification-code",
  createOrganization = "organizations-create",
  organizationListing = "organizations-list",
  whatsappTemplateListing = "whatsapp-template-list",
  whatsappTemplateCreate = "whatsapp-template-create",
  smsTemplateListing = "sms-template-list",
  smsTemplateCreate = "sms-template-create",
  editOrganization = "organizations-edit",
  deleteOrganization = "organizations-delete",
  viewOrganization = "organizations-show",
  downloadOrgListPdf = "organizations-download-pdf",
  downloadOrgListExcel = "organizations-download-excel",
  resultTypeListing = "resultType-list",
  resultTypeCreate = "resultType-create",
  viewResultType = "resultType-show",
  editResultType = "resultType-edit",
  deleteResultType = "resultType-delete",
  downloadResultTypePDF = "resultType-download-pdf",
  downloadResultTypeExcel = "resultType-download-excel",
  createAsset = "assets-create",
  assetsListing = "assets-list",
  viewAsset = "assets-show",
  editAsset = "assets-edit",
  deleteAsset = "assets-delete",
  downloadAssetListPdf = "assets-download-pdf",
  downloadAssetListExcel = "assets-download-excel",
  createBuilding = "building-create",
  buildingListing = "building-list",
  createBuildingStructure = "BuildingType-create",
  editeBuildingStructure = "BuildingType-edit",
  deleteBuildingStructure = "BuildingType-delete",
  buildingStructureListing = "BuildingType-list",
  viewbuildingStructure = "BuildingType-show",
  editBuilding = "building-edit",
  viewBuilding = "building-show",
  deleteBuilding = "building-delete",
  downloadBuildingListPdf = "building-download-pdf",
  downloadBuildingListExcel = "building-delete",
  createStructureType = "structure-types-create",
  structureTypeListing = "structure-types-list",
  editStructureType = "structure-types-edit",
  viewStructureType = "structure-types-show",
  deleteStructureType = "structure-types-delete",
  downloadStructureTypesListPdf = "structure-types-download-pdf",
  downloadStructureTypesListExcel = "structure-types-download-excel",
  createOrgStructure = "structure-create",
  orgStructureListing = "structure-list",
  editOrgStructure = "structure-edit",
  deleteOrgStructure = "structure-delete",
  viewOrgStructure = "structure-show",
  downloadOrgStructureListPdf = "structure-download-pdf",
  downloadOrgStructureListExcel = "structure-download-excel",
  superAdminDashboard = "super-admin-dashboard",
  adminDashboard = "admin-dashboard",
  adminLogin = "admin-login",
  superAdminLogin = "super-admin-login",
  createProgram = "program-create",
  programListing = "program-list",
  editProgram = "program-edit",
  viewProgram = "program-show",
  deleteProgram = "program-delete",
  downloadProgramsPDF = "program-download-pdf",
  downloadProgramsExcel = "program-download-excel",

  programCategoryTypesListing = "program-category-types-list",
  createProgramCategoryType = "program-category-types-create",
  editProgramCategoryType = "program-category-types-edit",
  viewProgramCategoryType = "program-category-types-show",
  deleteProgramCategoryType = "program-category-types-delete",

  examInchargePrograms = "Academics-ExamIncharge-Programs",
  examInchargeSections = "Academics-ExamIncharge-Sections",
  examInchargeCourses = "Academics-ExamIncharge-Courses",
  academicExamResultsSkippedListing = "Academic-exam-result-skipped-list",

  resportsCreate = "Report-add",
  resportsListing = "Report-list",
  reportsDashboard = "Report-dashboard",
  resportsDelete = "Report-delete",
  resportsUpdate = "Report-update",

  shortCoursesApply = "short-courses-apply",
  ePShortAppliedCoursesListing = "short-courses-applied-list",
  ePortalShortCoursesListing = "short-courses-list-user",

  manageProgramExamIncharge = "program-manage-exam-incharge",
  manageProgramCriteria = "program-manage-criteria",
  manageProgramSeats = "program-manage-seats",
  programSpecialization = "program-specialization",
  programLinkToEntryTest = "program-link-to-entry-test",
  ePortalLogin = "eportal-login",
  ePortalRegister = "eportal-register",
  ePortalResetPassword = "eportal-reset-password",
  ePortalDashboard = "user-dashboard",
  ePortalEditProfile = "UserProfile-edit",
  ePortalEditProfileAddtionalInofrmation = "UserProfile-edit",
  sPortalEditProfile = "StudentPortal-Mylinks-profile-edit",
  ePortalMyVouchers = "eportal-my-vouchers",
  uploadFinancialVoucher = "StudentPortal-upload-financial-voucher",
  eportalHostelPortal = "hostel-dashboard",
  eportalHostelApplyDashboard = "hostel-apply-now-dashboard",
  eportalHostelApplyNow = "hostel-apply-now",
  eportalHostelVoucherListing = "hostel-vouchers",
  eportalDownloadHostelVoucher = "hostel-download-voucher",
  eportalUploadHostelVoucher = "hostel-upload-voucher",
  eportalUploadCloudHostelVoucher = "hostel-download-voucher-cloud",
  eportalHostelVisitorsInfo = "hostel-visitors-dashboard",
  eportalHostelVisitorCreate = "hostel-visitors-create",
  eportalHostelVisitorEdit = "hostel-visitors-edit",
  eportalHostelVisitorDelete = "hostel-visitors-delete",
  eportalHostelMedicalInfo = "medical-and-others-dashboard",
  eportalHostelMedicalCreate = "medical-and-others-create",
  eportalHostelEnrollmentInfo = "enrollment-dashboard",
  createHostel = "hostel-create",
  hostelListing = "hostel-list",
  hostelDelete = "hostel-delete",
  hostelEdit = "hostel-edit",
  downloadHostelPDF = "download-hostel-pdf",
  downloadHostelExcel = "download-hostel-excel",
  createHostelRoom = "hostel-room-create",
  hostelRoomsListing = "hostel-room-list",
  hostelRoomsDelete = "hostel-room-delete",
  hostelRoomsEdit = "hostel-room-edit",
  hostelRoomsDownloadPDF = "hostel-room-download-pdf",
  hostelRoomsDownloadExcel = "hostel-room-download-excel",
  applicantListing = "hostel-applicant-list",
  createApplicant = "hostel-applicant-create",
  editHostelApplicant = "hostel-applicant-edit",
  deleteHostelApplicant = "hostel-applicant-delete",
  downloadHostelApplicantPDF = "hostel-applicant-download-pdf",
  downloadHostelApplicantExcel = "hostel-applicant-download-excel",
  createHostelMerit = "hostel-merit-list-create",
  hostelMeritListing = "hostel-merit-list-listing",
  editHostelMerit = "hostel-merit-list-edit",
  deleteHostelMerit = "hostel-merit-list-delete",
  downloadHostelMeritPDF = "hostel-merit-list-download-pdf",
  downloadHostelMeritExcel = "hostel-merit-list-download-excel",
  createHostelSession = "hostel-session-create",
  hostelSessionListing = "hostel-session-listing",
  editHostelSession = "hostel-session-edit",
  deleteHostelSession = "hostel-session-delete",
  downloadHostelSessionPDF = "hostel-session-download-pdf",
  downloadHostelSessionExcel = "hostel-session-download-excel",
  hostelFinanceManagement = "hostel-finance-management",
  viewAppliedApplicant = "applicants-applied-for-hostel-detail",
  rejectAppliedApplicant = "applicants-applied-for-hostel-reject",
  acceptAppliedApplicant = "applicants-applied-for-hostel-accept",
  filterAppliedApplicants = "applicants-applied-for-hostel-filter",
  appliedApplicant = "applicants-applied-for-hostel-list",
  downloadAppliedApplicantsPDF = "applicants-applied-for-hostel-download-pdf",
  downloadAppliedApplicantsExcel = "applicants-applied-for-hostel-download-excel",
  createHostelAllocation = "applicants-hostel-enrollment-create",
  applicantEnrollment = "applicants-hostel-enrollment-list",
  editApplicantEnrollment = "applicants-hostel-enrollment-edit",
  deleteApplicantEnrollment = "applicants-hostel-enrollment-delete",
  downloadApplicantEnrollmentPDF = "applicants-hostel-enrollment-download-pdf",
  downloadApplicantEnrollmentExcel = "applicants-hostel-enrollment-download-excel",
  applicantEnrollmentFilter = "applicants-hostel-enrollment-filter",
  generateApplicantEnrollmentChallan = "applicants-hostel-enrollment-generate-challan",
  registeredApplicantList = "hostel-registered-applicant-list",
  createRegisteredApplicant = "hostel-registered-applicant-create",
  editRegisteredApplicant = "hostel-registered-applicant-edit",
  deleteRegisterApplicant = "hostel-registered-applicant-delete",
  registeredApplicantFilter = "hostel-registered-applicant-filter",
  downloadRegisteredApplicantPDF = "hostel-registered-applicant-download-pdf",
  downloadRegisteredApplicantExcel = "hostel-registered-applicant-download-excel",
  hostelApplicantMeritList = "hostel-applicant-merit-list-listing",
  editHostelApplicantMeritList = "hostel-applicant-merit-list-edit",
  deleteHostelApplicantMeritList = "hostel-applicant-merit-list-delete",
  hostelApplicantMeritListFilter = "hostel-applicant-merit-list-filter",
  downloadHostelApplicantMeritListPDF = "hostel-applicant-merit-list-download-pdf",
  downloadHostelApplicantMeritListExcel = "hostel-applicant-merit-list-download-excel",
  academicSessionListing = "Academics-session-listing",
  academicSessionEdit = "Academics-session-edit",
  academicSessionDelete = "Academics-session-delete",
  academicSessionMarkWSA = "Academics-session-mark-wsa",
  academicSessionMarkDebar = "Academics-session-mark-debar",
  academicSessionRevertWSA = "Academics-session-revert-wsa",
  academicStudentDeclaredResult = "Academics-student-declared-result",
  academicStudentDeclaredResultTranscript = "Academics-student-declared-result-transcript",
  academicAnnounceResult = "Academics-announce-result",
  academicStudentIssueTranscript = "Academics-student-issue-transcript",
  academicDownloadGradeSheet = "Academics-download-grade-sheet",
  academicFGradeStudentsReport = "Academics-f-grade-students-report",
  overwriteGrade = "Academics-overwrite-grade",
  batchGradeSheet = "Academics-batch-grade-sheet",
  batchExcelTranscript = "Academics-batch-excel-transcript",
  academicProgramAdvisingDashboard = "Academics-ProgramAdvising-dashboard",
  lmsDashboard = "LMS-Dashboard",
  lmsSyncAudit = "LMS-Sync",
  lmsSync = "LMS-Sync",

  // academic batch
  academicBatchListing = "Academics-Batches-list",
  createAcademicBatch = "Academics-Batches-create",
  editAcademicBatch = "Academics-Batches-edit",
  deleteAcademicBatch = "Academics-Batches-delete",
  // academic batch semester
  academicBatchSemesterListing = "Academics-Batches-Sections-Semesters-list",
  createAcademicBatchSemester = "Academics-Batches-Sections-Semesters-create",
  editAcademicBatchSemester = "Academics-Batches-Sections-Semesters-edit",
  deleteAcademicBatchSemester = "Academics-Batches-Sections-Semesters-delete",

  createAdmissionSession = "sessions-create",

  academicsCourseMaterialUpload = "study-material-create",
  academicsCourseMaterialList = "study-material-list",
  academicsCourseMaterialUpdate = "study-material-edit",
  academicsCourseMaterialDelete = "study-material-delete",
  academicsCourseMaterialShow = "study-material-show",

  academicTemplateCourseReferenceBooks = "reference-books-list",
  academicTemplateCourseReferenceBooksCreate = "reference-books-create",
  academicTemplateCourseReferenceBooksEdit = "reference-books-edit",
  academicTemplateCourseReferenceBooksDelete = "reference-books-delete",
  academicTemplateCourseReferenceBooksShow = "reference-books-show",

  viewEportalProfile = "UserProfile-show",
  admissionSessionListing = "sessions-list",
  admissionCampaignListing = "AdmissionCampaigns-list",
  createAdmissionCampaign = "AdmissionCampaigns-create",
  ViewAdmissionCampaign = "AdmissionCampaigns-show",
  EditAdmissionCampaign = "AdmissionCampaigns-edit",
  deleteAdmissionCampaign = "AdmissionCampaigns-delete",
  admissionCampaignLinkProgram = "AdmissionCampaigns-link-program",
  downloadAdmissionCampaignPDF = "AdmissionCampaigns-download-pdf",
  downloadAdmissionCampaignExcel = "AdmissionCampaigns-download-excel",
  admissionStudentListing = "StudentApplications-list",
  admissionStudentMeritListing = "StudentApplicationsMerit-list",
  admissionStudentMeritUpdateFee = "StudentApplicationsMerit-update-fee",

  admissionAgenciesListing = "Agencies-list",
  admissionAgenciesCreate = "Agencies-create",
  admissionAgenciesShow = "Agencies-show",
  admissionAgenciesEdit = "Agencies-edit",
  admissionAgenciesDelete = "Agencies-delete",

  admissionAgenciesAgentsListing = "agent_linked_agency-list",
  admissionAgenciesAgentsCreate = "agent_linked_agency-create",
  admissionAgenciesAgentsDelete = "agent_linked_agency-delete",
  admissionAgenciesLinkedUserListing = "users_linked_agency-list",
  admissionAgenciesLinkedUserCreate = "users_linked_agency-create",
  admissionAgenciesLinkedUserDelete = "users_linked_agency-delete",
  admissionAgenciesAgentsUpdateRemarks = "users_linked_agency-update",

  admissionCohortManagementListing = "Admission-cohort-list",
  admissionCohortManagementCreate = "Admission-cohort-create",
  admissionCohortManagementUpdate = "Admission-cohort-edit",
  admissionCohortManagementDelete = "Admission-cohort-delete",
  admissionCohortManagementGet = "Admission-cohort-show",
  admissionCohortManagementCuttoffListing = "Admission-cutoff-list",
  admissionCohortManagementCuttoffCreate = "Admission-cutoff-create",
  admissionCohortManagementCuttoffUpdate = "Admission-cutoff-edit",
  admissionCohortManagementCuttoffDelete = "Admission-cutoff-delete",
  admissionCohortManagementCuttoffGet = "Admission-cutoff-show",

  admissionCrmMetaLeadsListing = "Admission-crm-meta-leads-list",
  admissionCrmMetaLeadsCreate = "Admission-crm-meta-leads-create",
  admissionCrmMetaLeadsShow = "Admission-crm-meta-leads-show",
  admissionCrmMetaLeadsUpdate = "Admission-crm-meta-leads-edit",
  admissionCrmMetaLeadsDelete = "Admission-crm-meta-leads-delete",
  admissionCrmMetaLeadsShowAllLeads = "Admission-crm-meta-leads-show-all-leads",

  outreachEventListing = "Outreach-event-list",
  createOutreachEvent = "Outreach-event-create",
  outreachEventParticipantListing = "Outreach-event-participant-list",
  createOutreachEventParticipant = "Outreach-event-participant-create",

  admissionCohortManagementProgramsListing = "Admission-cohort-linked-programs-list",
  admissionCohortManagementProgramsCreate = "Admission-cohort-linked-programs-create",
  admissionCohortManagementProgramsDelete = "Admission-cohort-linked-programs-delete",

  admissionStudentDownloadListing = "StudentApplications-download-list",
  admissionStudentDownloadPDF = "StudentApplications-download-pdf",
  admissionStudentUnlockMeritList = "Admission-Locked-MeritList-delete",
  admissionStudentDownloadExcel = "StudentApplications-download-excel",
  admissionApplicantsListing = "StudentApplicationsView-list",
  downloadAdmissionApplicantsPDF = "StudentApplicationsView-download-pdf",
  downloadAdmissionApplicantsExcel = "StudentApplicationsView-download-excel",
  editAdmissionApplicants = "StudentApplicationsView-edit",
  deleteAdmissionApplicants = "StudentApplicationsView-delete",
  emailAdmissionApplicants = "StudentApplicationsView-email",
  phoneAdmissionApplicants = "StudentApplicationsView-phone",
  editAdmissionDocument = "ManageDocuments-edit",
  createAdmissionDocument = "ManageDocuments-create",
  admissionDocumentListing = "ManageDocuments-list",
  admissionDocumentDelete = "ManageDocuments-delete",
  downloadAdmissionDocumentsPDF = "ManageDocuments-download-pdf",
  downloadAdmissionDocumentsExcel = "ManageDocuments-download-excel",
  admissionTestTypesListing = "TestingServices-TestTypes-list",
  testTypesListing = "TestingServices-TestTypes-list",
  createTestType = "TestingServices-TestTypes-create",
  createAdmissionTestType = "TestingServices-TestTypes-create",
  editAdmissionTestType = "TestingServices-TestTypes-edit",
  deleteAdmissionTestType = "TestingServices-TestTypes-delete",
  showAdmissionTestType = "TestingServices-TestTypes-show",
  downloadAdmissionTestTypePDF = "TestingServices-TestTypes-download-pdf",
  downloadAdmissionTestTypeExcel = "TestingServices-TestTypes-download-excel",
  studentRegListing = "RegisteredStudents-list",
  studentRegEdit = "RegisteredStudents-edit",
  studentRegDelete = "RegisteredStudents-delete",
  studentRegEmail = "RegisteredStudents-email",
  studentRegPhone = "RegisteredStudents-phone",
  downloadStudentRegPDF = "RegisteredStudents-download-pdf",
  downloadStudentRegExcel = "RegisteredStudents-download-excel",
  feeRefundListing = "FeeRefundListing-list",
  feeRefundListingEmail = "FeeRefundListing-email",
  feeRefundListingPhone = "FeeRefundListing-phone",
  downloadFeeRefundListingPDF = "FeeRefundListing-download-pdf",
  downloadFeeRefundListingExcel = "FeeRefundListing-download-excel",
  orientationResponseListing = "OrientationResponse-list",
  eportalOrientationResponse = "Applications-list",
  admissionMeritListing = "AdmissionMeritList-list",
  admissionMeritListEdit = "AdmissionMeritList-edit",
  admissionMeritListUpdateFee = "AdmissionMeritList-update-fee",
  downloadAdmissionMeritListPDF = "AdmissionMeritList-download-pdf",
  downloadAdmissionMeritListExcel = "AdmissionMeritList-download-excel",
  admissionMeritListForward = "AdmissionMeritList-forward",
  admissionMeritListDelete = "AdmissionMeritList-delete",
  admissionMeritListDownload = "AdmissionMeritList-download",
  admissionMeritListAllField = "AdmissionMeritList-download-allFields",

  addmissionOfferLetterLinkProgramListing = "offer-letter-link-program-list",
  addmissionOfferLetterLinkProgramCreate = "offer-letter-link-program-create",
  addmissionOfferLetterLinkProgramDelete = "offer-letter-link-program-delete",

  admissionOfferLetterListing = "OfferLetterTemplates-list",
  createAdmissionOfferLetter = "OfferLetterTemplates-create",
  editAdmissionOfferLetter = "OfferLetterTemplates-edit",
  showAdmissionOfferLetter = "OfferLetterTemplates-show",
  deleteAdmissionOfferLetter = "OfferLetterTemplates-delete",
  downloadAdmissionOfferLetterPDF = "OfferLetterTemplates-download-pdf",
  downloadAdmissionOfferLetterExcel = "OfferLetterTemplates-download-excel",
  editAdmissionBoard = "edit-admission-board",
  editAdmissionCertificate = "edit-admission-certificate",
  admissionManageDocumentsMasterListing = "admission-manage-documents-master-listing",
  createAdmissioneligibilityTemplateHeaders = "EligibilityTemplateHeader-create",
  admissioneligibilityTemplateHeadersListing = "EligibilityTemplateHeader-list",
  admissioneligibilityTemplateHeadersDelete = "EligibilityTemplateHeader-delete",
  admissioneligibilityTemplateHeadersEdit = "EligibilityTemplateHeader-edit",
  admissioneligibilityTemplateHeadersShow = "EligibilityTemplateHeader-show",
  downloadAdmissionEligibilityTemplateHeaderPDF = "EligibilityTemplateHeader-download-pdf",
  downloadAdmissionEligibilityTemplateHeaderExcel = "EligibilityTemplateHeader-download-excel",
  createAdmissioneligibilityTemplateBody = "EligibilityTemplateBody-create",
  admissioneligibilityTemplateBodiesListing = "EligibilityTemplateBody-list",
  admissioneligibilityTemplateBodyDelete = "EligibilityTemplateBody-delete",
  admissioneligibilityTemplateBodyEdit = "EligibilityTemplateBody-edit",
  admissioneligibilityTemplateBodyShow = "EligibilityTemplateBody-show",
  downloadAdmissionEligibilityTemplateBodyPDF = "EligibilityTemplateBody-download-pdf",
  downloadAdmissionEligibilityTemplateBodyExcel = "EligibilityTemplateBody-download-excel",
  admissionQuotasListing = "AdmissionQuota-list",
  createAdmissionQuotas = "AdmissionQuota-create",
  editAdmissionQuotas = "AdmissionQuota-edit",
  showAdmissionQuotas = "AdmissionQuota-show",
  deleteAdmissionQuotas = "AdmissionQuota-delete",
  downloadAdmissionQuotaPDF = "AdmissionQuota-download-pdf",
  downloadAdmissionQuotaExcel = "AdmissionQuota-download-excel",
  ePortalChallanListing = "UserChallan-generate",
  eportalChallanDownloadPDF = "UserChallan-download-pdf",
  eportalChallanDownloadExcel = "UserChallan-download-excel",
  certificateLinkListing = "LinkedCertificates-list",
  certificateLinkCreate = "LinkedCertificates-create",
  viewCertificateLink = "LinkedCertificates-show",
  editLinkedCertificate = "LinkedCertificates-edit",
  deleteLinkedCertificate = "LinkedCertificates-delete",
  downloadLinkedCertificatePDF = "LinkedCertificates-download-pdf",
  downloadLinkedCertificateExcel = "LinkedCertificates-download-excel",
  roleManagementListing = "admin-roles-listing",
  rollManagementCreate = "admin-roles-create",
  roleManagementShow = "admin-roles-show",
  roleManagementEdit = "admin-roles-edit",
  roleManagementDelete = "admin-roles-delete",
  roleManagementPDFDownload = "admin-roles-download-pdf",
  roleManagementExcelDownload = "admin-roles-download-excel",
  boardManagementListing = "Boards-list",
  boardManagementCreate = "Boards-create",
  boardManagementDelete = "Boards-delete",
  boardManagementEdit = "Boards-edit",
  boardManagementShow = "Boards-show",
  downloadBoardManagementPDF = "Boards-download-pdf",
  downloadBoardManagementExcel = "Boards-download-excel",
  subjectManagementListing = "Subjects-list",
  subjectManagementCreate = "Subjects-create",
  subjectManagementShow = "Subjects-show",
  subjectManagementEdit = "Subjects-edit",
  subjectManagementDelete = "Subjects-delete",
  downloadSubjectManagementPDF = "Subjects-download-pdf",
  downloadSubjectManagementExcel = "Subjects-download-excel",
  certificateManagementListing = "certificate-management-listing",
  certificateManagementCreate = "certificate-management-create",
  superAdminManagementListing = "super-admins-list",
  superAdminManagementCreate = "super-admins-create",
  superAdminManagementDelete = "super-admins-delete",
  superAdminManagementEdit = "super-admins-edit",
  superAdminManagementShow = "super-admins-show",
  superAdminManagementPDFDownload = "super-admins-download-pdf",
  superAdminManagementExcelDownload = "super-admins-download-excel",
  superRoleManagementListing = "roles-list",
  superRoleManagementCreate = "roles-create",
  superRoleManagementShow = "roles-show",
  superRoleManagementEdit = "roles-edit",
  superRoleManagementDelete = "roles-delete",
  superRoleManagementPDFDownload = "roles-download-pdf",
  superRoleManagementExcelDownload = "roles-download-excel",
  permissionManagementListing = "permissions-list",
  permissionManagementCreate = "permissions-create",
  myPermissionsList = "my-permissions-list",
  permissionManagementEdit = "permissions-edit",
  permissionManagementDelete = "permissions-delete",
  permissionManagementPDFDownload = "permissions-download-pdf",
  permissionManagementExcelDownload = "permissions-download-excel",
  moduleManagement = "modules-list",
  moduleManagementCreate = "modules-create",
  moduleManagementDelete = "modules-delete",
  moduleManagementEdit = "modules-edit",
  moduleManagementSettingsEdit = "modules-settings-edit",
  downloadModulesPdf = "modules-download-pdf",
  downloadModulesExcel = "modules-download-excel",
  linkedSpecializationListing = "LinkedSpecialization-list",
  createLinkedSpecialization = "LinkedSpecialization-create",
  viewLinkedSpecialization = "LinkedSpecialization-show",
  EditLinkedSpecialization = "LinkedSpecialization-edit",
  deleteLinkedSpecialization = "LinkedSpecialization-delete",
  downloadLinkedSpecializationPDF = "LinkedSpecialization-download-pdf",
  downloadLinkedSpecializationExcel = "LinkedSpecialization-download-excel",
  linkedProgramEntryTestListing = "LinkProgramToEntryTest-list",
  createLinkedProgramEntryTest = "LinkProgramToEntryTest-create",
  deleteLinkedProgramEntryTest = "LinkProgramToEntryTest-delete",
  editLinkedProgramEntryTest = "LinkProgramToEntryTest-edit",
  showLinkedProgramEntryTest = "LinkProgramToEntryTest-show",
  downloadLinkedProgramEntryTestPDF = "LinkProgramToEntryTest-download-pdf",
  downloadLinkedProgramEntryTestExcel = "LinkProgramToEntryTest-download-excel",
  academicSessionOrganizationListing = "academic-session-organization-listing",
  createAcademicSessionOrganization = "create-academic-session-organization",
  admissionProgramListing = "admission-program-listing",
  admissionSubjectManagementListing = "Subjects-list",
  createAdmissionSubjectManagement = "Subjects-create",
  admissionBoardManagementListing = "admission-board-management-listing",
  createAdmissionBoardManagement = "create-admission-board-management",
  admissionCertificateManagementListing = "DegreeCertificate-list",
  createAdmissionCertificateManagement = "DegreeCertificate-create",
  editAdmissionCertificateManagement = "DegreeCertificate-edit",
  showAdmissionCertificateManagement = "DegreeCertificate-show",
  deleteAdmissionCertificateManagement = "DegreeCertificate-delete",
  downloadAdmissionCertificateManagementPDF = "DegreeCertificate-download-pdf",
  downloadAdmissionCertificateManagementExcel = "DegreeCertificate-download-excel",
  linkedProgramAdmissionListing = "linked-program-admission-listing",
  meritKeysListing = "MeritKeys-list",
  createMeitKeys = "MeritKeys-create",
  editMeritKeys = "MeritKeys-edit",
  showMeritKeys = "MeritKeys-show",
  deleteMeritKeys = "MeritKeys-delete",
  downloadMeritKeysPDF = "MeritKeys-download-pdf",
  downloadMeritKeysExcel = "MeritKeys-download-excel",
  meritListFormulaListing = "MeritListFormula-list",
  createMeritListFormula = "MeritListFormula-create",
  editMeritListFormula = "MeritListFormula-edit",
  showMeritListFormula = "MeritListFormula-show",
  deleteMeritListFormula = "MeritListFormula-delete",
  downloadMeritListFormulaPDF = "MeritListFormula-download-pdf",
  downloadMeritListFormulaExcel = "MeritListFormula-download-excel",
  majorCategoriesListing = "AssetsMajorCategory-list",
  CreateMajorCategories = "AssetsMajorCategory-create",
  viewAssetsMajorCategories = "AssetsMajorCategory-show",
  editAssetsMajorCategories = "AssetsMajorCategory-edit",
  deleteAssetsMajorCategories = "AssetsMajorCategory-delete",
  downloadAssetsMajorCategoriesPDF = "AssetsMajorCategory-download-pdf",
  downloadAssetsMajorCategoriesExcel = "AssetsMajorCategory-download-excel",
  minorCategoriesListing = "AssetsMinorCategory-list",
  createMinorCategories = "AssetsMinorCategory-create",
  viewMinorCategories = "AssetsMinorCategory-show",
  editMinorCategories = "AssetsMinorCategory-edit",
  deleteMinorCategories = "AssetsMinorCategory-delete",
  downloadMinorCategoriesPDF = "AssetsMinorCategory-download-pdf",
  downloadMinorCategoriesExcel = "AssetsMinorCategory-download-excel",
  roomsListing = "Rooms-list",
  createRooms = "Rooms-create",
  editRooms = "Rooms-edit",
  showRooms = "Rooms-show",
  deleteRooms = "Rooms-delete",
  eportalMyVouchersListing = "eportal-my-vouchers-listing",
  eportalCareersListing = "eportal-careers-listing",
  eportalAdmissionsListing = "Applications-list",
  eportalTestingServiceListing = "TestingServices-MyTestResult-list",
  buildingTypeListing = "BuildingType-list",
  createBuildingType = "BuildingType-create",
  viewBuildingTop = "BuildingType-show",
  editBuildingType = "BuildingType-edit",
  deleteBuildingType = "BuildingType-delete",
  downloadBuildingTypePDF = "BuildingType-download-pdf",
  downloadBuildingTypeExcel = "BuildingType-download-excel",
  assetTypeListing = "AssetType-list",
  createAssetType = "AssetType-create",
  editAssetType = "AssetType-edit",
  deleteAssetType = "AssetType-delete",
  roomTypeListing = "RoomType-list",
  createRoomType = "RoomType-create",
  editRoomType = "RoomType-edit",
  deleteRoomType = "RoomType-delete",
  createEportalAdmissionList = "Applications-apply-in-othe-program",
  quotasAdmissionListing = "AdmissionQuota-list",
  createQuotasAdmissionList = "AdmissionQuota-create",
  manageMeritListListing = "ManageMeritList-list",
  createAdmissionManageMeritList = "ManageMeritList-create",
  editAdmissionManageMeritList = "ManageMeritList-edit",
  deleteAdmissionManageMeritList = "ManageMeritList-delete",
  downloadManageMeritListPDF = "ManageMeritList-download-pdf",
  downloadManageMeritListExcel = "ManageMeritList-download-excel",
  downloadManageMeritListLockedList = "ManageMeritList-download-locked-list",
  downloadManageMeritListAwaitingList = "ManageMeritList-download-awaiting-list",
  extendManageMeritListDate = "ManageMeritList-extend-date",
  sendManageMeritListMail = "ManageMeritList-send-mail",
  generateManageMeritList = "ManageMeritList-bulk-lock-list",
  publishManageMeritList = "ManageMeritList-publish",
  unpublishManageMeritList = "ManageMeritList-unpublish",
  removeManageMeritList = "ManageMeritList-bulk-unlock-step",
  bulkLockManageMeritListUsingExcel = "ManageMeritList-bulk-lock-using-excel",
  downloadManageMeritListSummary = "ManageMeritList-download-summary",
  qoutasListProgramListing = "quota-list-program-listing",
  eligibilityTemplatesListing = "ProgramLinkTemplate-list",
  eligibilityTemplatesCreate = "ProgramLinkTemplate-create",
  programLinkMeritList = "ProgramLinkMerit-list",
  programLinkQuotaList = "AdmissionQuota-list",
  createProgramLinkMeritList = "ProgramLinkMerit-create",
  systemLogsListing = "Logs-system-logs-listing",
  feeIncomeDashboard = "Finance-finance-dashboard",
  financeOnlineDashboard = "Finance-online-dashboard",
  smartpayDashboard = "Finance-smartpay-dashboard",
  systemUsersListing = "Users-system-users-listing",
  createSystemUsers = "Users-create-system-users",
  referralsListing = "referrals-list",
  createReferral = "referrals-create",
  systemMenusListing = "Menus-system-menus-listing",
  createSystemMenus = "Menus-create-system-menus",
  unregisteredMenusListing = "Menus-system-unregistered-menus-listing",
  userAuditListing = "Audit-system-user-audit-listing",
  workflowListing = "Workflow-system-workflow-listing",
  workflowMyPendingApprovals = "Workflow-my-pending-approvals",
  createWorkflow = "Workflow-create-system-workflow",

  minuteSheetListing = "minute-sheet-list",
  minuteSheetAllListing = "minute-sheet-all-list",
  minuteSheetTrackingListing = "minute-sheet-tracking-list",
  minuteSheetInbox = "minute-sheet-inbox",
  minuteSheetOutbox = "minute-sheet-outbox",
  minuteSheetInitiate = "minute-sheet-initiate",
  minuteSheetSeriesListing = "minute-sheet-series-list",
  minuteSheetSeriesCreate = "minute-sheet-series-create",

  procurementMaterialRequestListing = "Procurement-list",
  createProcurementMaterialRequest = "Procurement-create",
  editProcurementMaterialRequest = "Procurement-edit",
  deleteProcurementMaterialRequest = "Procurement-delete",
  approveProcurementByDean = "Procurement-approveByDean",
  approveProcurementByDeanListing = "Procurement-approveByDean-list",
  approveProcurementByHod = "Procurement-approveByHoD",
  approveProcurementByHodListing = "Procurement-approveByHoD-list",
  approveProcurementByAdmin = "Procurement-approveByAdmin",
  approveProcurementByAdminListing = "Procurement-approveByAdmin-list",
  approveProcurementByViceChancellor = "Procurement-approveByViceChancellor",
  approveProcurementByViceChancellorListing = "Procurement-approveByViceChancellor-list",
  approveProcurementByStores = "Procurement-approveByStores",
  approveProcurementByStoresListing = "Procurement-approveByStores-list",
  approveProcurementByChiefProcurement = "Procurement-approveByChiefProcurement",
  approveProcurementByChiefProcurementListing = "Procurement-approveByChiefProcurement-list",

  // Budget Estimation
  budgetEstimationListing = "BudgetEstimation-list",
  myBudgetEstimationListing = "BudgetEstimation-my-list",
  allBudgetEstimationListing = "BudgetEstimation-all-list",
  createBudgetEstimation = "BudgetEstimation-create",
  viewBudgetEstimation = "BudgetEstimation-show",
  approveBudgetEstimation = "BudgetEstimation-approve",
  approveBudgetEstimationByHodListing = "BudgetEstimation-approveByHoD-list",
  approveBudgetEstimationByDirectorFinanceListing = "BudgetEstimation-approveByDirectorFinance-list",

  createEportalCareer = "career-create-eportal-careers",
  careerEportalListing = "career-eportal-careers-listing",
  studentFinancialClearanceListing = "Finance-student-financial-clearance-listing",
  checkFinancialChallanStatus = "Finance-check-financial-challan-status",
  exchangeRatesListing = "Finance-exchange-rates-listing",
  studentWalletsListing = "Finance-student-wallets-list",
  studentWalletsShow = "Finance-student-wallets-show",
  studentWalletsCredit = "Finance-student-wallets-credit",
  studentWalletsDebit = "Finance-student-wallets-debit",
  studentWalletsPayChallan = "Finance-student-wallets-pay-challan",
  createExchangeRate = "Finance-create-exchange-rate",
  fineSlotsListing = "Finance-fine-slots-listing",
  createFineSlot = "Finance-create-fine-slot",
  templateProgramAccountCodeListing = "Finance-template-program-account-code-listing",
  voucherTypesListing = "Finance-voucher-types-listing",
  createVoucherType = "Finance-create-voucher-type",
  createFinanceApplications = "Finance-create-finance-application",
  financeApplicationsListing = "Finance-finance-applications-listing",
  applicationTemplateLinkListing = "Finance-application-template-link-listing",
  createApplicationTemplateLink = "Finance-create-application-template-link",
  createVoucherTemplateHeader = "Finance-create-voucher-template-header",
  voucherTemplateHeaderListing = "Finance-voucher-template-header-listing",
  systemDesignAndReviewListing = "Design-and-review-list",
  systemDesignAndReviewCreate = "Design-and-review-create",
  systemDesignAndReviewShow = "Design-and-review-show",
  systemDesignAndReviewEdit = "Design-and-review-edit",
  systemDesignAndReviewUpdateStatus = "Design-and-review-update-status",
  systemDesignAndReviewDelete = "Design-and-review-delete",

  manualVouchersListing = "Finance-manual-vouchers-list",
  manualVouchersCreate = "Finance-manual-vouchers-create",
  manualVouchersShow = "Finance-manual-vouchers-show",
  manualVouchersEdit = "Finance-manual-vouchers-edit",
  manualVouchersDelete = "Finance-manual-vouchers-delete",

  createBank = "Finance-create-bank",
  banksListing = "Finance-banks-listing",
  bankTransactionLogsListing = "Finance-bank-transactions-logs-listing",
  bankScrollLogsListing = "Finance-bank-scroll-logs-listing",
  createVoucherParticular = "Finance-create-voucher-particular",
  voucherParticularListing = "Finance-voucher-particulars-listing",
  masterBookListing = "Finance-master-book-listing",
  downloadChallansExcel = "Finance-master-book-excel",
  masterBookListingDelete = "Finance-master-book-delete",
  masterBookListingTrash = "Finance-master-book-listing-trash",
  masterBookListingDeleteTrash = "Finance-master-book-delete-trash",
  masterBookListingRestoreTrash = "Finance-master-book-delete-restore",
  masterBookTransactionDetail = "Finance-master-book-transaction-detail",
  showMasterBookTransactionDetail = "Finance-show-master-book-transaction-detail",
  masterBookUploadUpdate = "Finance-masterbook-upload",
  masterBookUpdateToPending = "Finance-masterbook-update-to-pending",
  eportalAppliedJobListing = "career-applied-jobs-listing",
  eportalCarrerProfile = "career-view-profile",
  careerDesignationListing = "career-designation-listing",
  createCareerDesignation = "career-create-career-designation",
  careerAdvertisementListing = "career-advertisement-listing",
  createCareerAdvertisement = "career-create-career-advertisement",
  careerPostTemplateListing = "career-post-template-listing",

  expirienceCriteriaListing = "experience-criteria-list",
  expirienceCriteriaCreate = "experience-criteria-create",
  expirienceCriteriaShow = "experience-criteria-show",
  expirienceCriteriaUpdate = "experience-criteria-update",
  expirienceCriteriaDelete = "experience-criteria-delete",

  applicantsCandidateProfile = "career-applicant-listing",
  careersApplicantsDetails = "career-applicant-listing",
  updateEportalCareerApplication = "job-application-profile-update",
  careersViewDocuments = "career-applicant-listing",

  createCareerPostTemplate = "career-create-career-post-template",
  careerPostListing = "career-post-listing",
  createCareerPost = "career-create-career-post",
  careerApplicantListing = "career-applicant-listing",
  voucherTemplateBodiesListing = "Finance-template-body-list",
  financeInstallmentListing = "Finance-installments-list",
  createFinanceInstallment = "Finance-installments-create",
  installmentSlotListing = "Finance-installment-slot-list",
  createInstallmentSlot = "Finance-installment-slot-create",
  slotsInstallmentParticulars = "Finance-installment-slot-particulars-list",
  CertificateLevelList = "CertificateLevels-list",
  createCertificateLevels = "CertificateLevels-create",
  editCertificateLevels = "CertificateLevels-edit",
  showCertificateLevels = "CertificateLevels-show",
  deleteCertificateLevels = "CertificateLevels-delete",
  downloadCertificateLevelsPdf = "CertificateLevels-download-pdf",
  downloadCertificateLevelsExcel = "CertificateLevels-download-excel",
  authoritiesListing = "Authorities-list",
  createAuthorities = "Authorities-create",
  viewMembers = "Authorities-view-member",
  viewDocuments = "Authorities-view-documents",
  senateMeetingList = "Authorities-SenataMeetings-list",
  createSenateMeeting = "Authorities-SenataMeetings-craete",
  councilNotificationsListing = "Authorities-CouncilNotification-list",
  createCouncilNotifications = "Authorities-CouncilNotification-create",
  authorityTypeListing = "Authorities-CommitteeType-list",
  createAuthorityType = "Authorities-CommitteeType-create",
  authorityMemberTypeListing = "Authorities-MemberType-list",
  createAuthorityMemberType = "Authorities-MemberType-create",
  testingServicesDashboard = "TestingServices-dashboard",
  TestingServicesTestCenterlist = "TestingServices-TestCenter-list",
  TestingServicesAddStudentsInBulk = "TestingServices-TestApplications-create",
  TestingServicesTestCentercreate = "TestingServices-TestCenter-create",
  TestingServicesTestSchedulelist = "TestingServices-TestSchedule-list",
  createTestingServicesTestSchedule = "TestingServices-TestSchedule-create",
  testingServicespublishresult = "TestingServices-publish-result",
  testingServicescandidateTestResultlist = "TestingServices-candidate-TestResult-list",
  testingCenterRooms = "TestingServices-TestCenterRooms-list",
  createTestingServicesTestCenterRooms = "TestingServices-TestCenterRooms-create",
  testingServicesTestScheduleSeatingPlanlist = "TestingServices-TestSchedule-SeatingPlan-list",
  testingServicesTestScheduleSeatingPlanRoomslist = "TestingServices-TestSchedule-SeatingPlan-Rooms-list",
  viewTestApplicants = "TestingServices-TestSchedule-SeatingPlan-application-list",
  testingServicescandidatelisting = "TestingServices-candidate-listing",
  reportCategoriesList = "QEC-ReportCategories-list",
  createreportCategories = "QEC-ReportCategories-create",
  qecReportManagelist = "QEC-Report-list",
  createQecReportManage = "QEC-Report-create",
  qecSurveyReportlist = "QEC-SurveyReport-list",
  createQecSurveyReport = "QEC-SurveyReport-create",
  // survey batches
  qecSurveyBatchlist = "QEC-Survey-batch-list",
  createQecSurveyBatch = "QEC-Survey-batch-create",
  qecSurveyBatchEdit = "qec-Survey-batch-edit",
  qecSurveyBatchDelete = "qec-Survey-batch-delete",
  qecSurveyBatchShow = "qec-Survey-batch-show",

  //survey semesters
  qecSurveySemesterlist = "QEC-Survey-semester-list",
  createQecSurveySemester = "QEC-Survey-semester-create",
  qecSurveySemestrEdit = "qec-Survey-semester-edit",
  qecSurveySemestrDelete = "qec-Survey-semester-delete",
  qecSurveySemestrShow = "qec-Survey-semester-show",

  // survey terms
  qecSurveyTermlist = "QEC-Survey-term-list",
  createQecSurveyTerm = "QEC-Survey-term-create",
  qecSurveyTerm = "qec-Survey-term-edit",
  qecSurveyTermDelete = "qec-Survey-term-delete",
  qecSurveyTermShow = "qec-Survey-term-show",

  surveyListing = "QEC-Survey-list",
  surveyParticipantsListing = "QEC-Survey-Participants-list",
  surveyAssignmentsListing = "QEC-Survey-Assignments-list",
  qecTeacherCourseEvaluationListing = "QEC-Teacher-Course-evaluation-listing",
  qecSurveyDashboard = "QEC-Survey-Dashboard",
  studentSurveyListing = "QEC-Survey-mysurveys-list",
  studentSurveyShow = "QEC-Survey-mysurveys-show",

  createSurvey = "QEC-Survey-create",
  surveyTypeListing = "QEC-SurveyType-list",
  createSurveyType = "QEC-SurveyType-create",
  questionListing = "QEC-SurveyQuestion-list",
  createQuestion = "QEC-SurveyQuestion-create",
  libraryPublisherlist = "Library-Publisher-list",
  createLibraryPublisher = "Library-Publisher-create",
  librarySellerlist = "Library-Seller-list",
  createLibrarySeller = "Library-Seller-create",
  libraryBillslist = "Library-Bills-list",
  createLibraryBills = "Library-Bills-create",
  libraryBookslist = "Library-Books-list",
  createLibraryBooks = "Library-Books-create",
  shortCoursesDashboard = "Academics-short-courses-dashboard",

  libraryLanguagelist = "Library-Language-list",
  createLibraryLanguage = "Library-Language-create",
  libraryAccessRegisterlist = "Library-AccessRegister-list",

  legalFrameworkList = "Legal-FrameworkDocument-list",
  createLegalFramework = "Legal-FrameworkDocument-create",
  legalOrganizationList = "Legal-DocumentOrganization-list",
  createLegalOrganization = "Legal-DocumentOrganization-create",
  frameworkDocumentTypeList = "Legal-FrameworkDocumentType-list",
  createFrameworkDocumentType = "Legal-FrameworkDocumentType-create",
  billRequestList = "Legal-BillRequest-list",
  createBillRequest = "Legal-BillRequest-create",
  legalCasesList = "Legal-LegalCase-list",
  createLegalCases = "Legal-LegalCase-create",
  legalAdvisorListing = "Legal-LegalAdvisor-list",
  createLegalAdvisor = "Legal-LegalAdvisor-create",
  createLegalAdvertisor = "Legal-LegalAdvisor-create",
  legalCourtList = "Legal-Courts-list",
  createLegalCourt = "Legal-Courts-create",
  legalStatusList = "Legal-Status-list",
  createLegalStatus = "Legal-Status-create",
  legalMatterTypeListing = "Legal-MatterTypes-list",
  createLegalMatterType = "Legal-MatterTypes-create",
  advisorRatesListing = "Legal-AdvisorRates-list",
  createAdvisorRates = "Legal-AdvisorRates-create",

  oricDashboard = "ORIC-Dashboard",
  oricEventTypesListing = "Oric-Event-Types-List",
  createOricEventTypes = "Oric-Event-Types-Create",
  oricConferenceListing = "Oric-Conferences-Listing",
  createOricConference = "Oric-Conferences-Create",
  oricCallListing = "Oric-Calls-Listing",
  createOricCalls = "Oric-Call-Create",
  oricCallCategoriesListing = "Oric-Call-Category-Listing",
  createOricCallCategories = "Oric-Call-Category-Create",
  oricCareerDevelopmentListing = "Oric-Career-Development-Listing",
  keyPerformanceIndicatorYearListing = "Key-Performance-Indicator-Year-Listing",
  createKeyPerformanceIndicatorYear = "Key-Performance-Indicator-Year-Create",
  oricKPIScore = "ORIC-KPI-Score",
  researchIncentivesListing = "Research-Incentives-Listing",
  createResearchIncentives = "Research-Incentives-Create",
  oricCommunityListing = "ORIC-community-list",
  publicationRewardsListing = "ORIC-publication-rewards-list",
  createPublicationReward = "ORIC-publication-rewards-create",
  createOricCommunity = "ORIC-community-create",
  oricMouPartyListing = "ORIC-MouParty-list",
  createOricMouParty = "ORIC-MouParty-create",
  oricMouListing = "ORIC-Mou-list",
  createOricMou = "ORIC-Mou-create",
  oricProjectDateListing = "ORIC-projectDate-list",
  createOricProjectDate = "ORIC-projectDate-create",
  oricProjectlisting = "ORIC-project-list",
  createOricProject = "ORIC-project-create",
  oricResearchGrantApplicationslisting = "ORIC-researchGrantApplications-list",
  oricResearchProjectListing = "ORIC-researchProject-list",
  createOricResearchProject = "ORIC-researchProject-create",
  oricMajorSubjectsListing = "ORIC-majorSubjects-list",
  createOricMajorSubjects = "ORIC-majorSubjects-create",

  // Access Templates
  accessTemplatesHeadersListing = "Access-Template-Headers-list",
  createAccessTemplatesHeaders = "Access-Template-Headers-create",
  accessTemplatesHeadersEdit = "Access-Template-Headers-edit",
  accessTemplatesHeadersDelete = "Access-Template-Headers-delete",
  accessTemplatesHeadersShow = "Access-Template-Headers-show",

  accessTemplatesBodyListing = "Access-Template-Body-list",
  createAccessTemplatesBody = "Access-Template-Body-create",
  accessTemplatesBodyEdit = "Access-Template-Body-edit",
  accessTemplatesBodyDelete = "Access-Template-Body-delete",
  accessTemplatesBodyShow = "Access-Template-Body-show",

  // academic permissions
  createAcademicCourse = "Academics-course-create",
  academicsAttendancePolicy = "Academics-attendance-policy",
  academicsGradePolicy = "Academics-grade-policy",
  academicsStudentMigration = "Academics-student-migration",
  academicCourseListing = "Academics-course-listing",

  academicSessionManagementListing = "Academics-session-management-listing",
  academicSessionExportStudents = "Academics-session-export-students",
  academicEnrollmentsListing = "Academics-enrollments-listing",
  downloadSoaReport = "Academics-download-soa-report",
  createAcademicCourseGroup = "Academics-courseGroup-create",
  academicCourseGroupListing = "Academics-courseGroup-listing",
  academicCalenderListing = "academic-calendar-events-list",
  academicCalenderCreate = "academic-calendar-events-create",
  academicCalenderEdit = "academic-calendar-events-edit",
  academicCalenderShow = "academic-calendar-events-show",
  academicCalenderDelete = "academic-calendar-events-delete",
  academicCalenderDownload = "academic-calendar-download",
  academicLmsOfferedCoursesCsv = "Academics-lms-offered-courses-csv",
  academicLmsEnrollmentsCsv = "Academics-lms-enrollments-csv",
  academicWeeklyReportsListing = "Academic-weeklyreport-list",
  academicWeeklyReportsCreate = "Academic-weeklyreport-create",
  academicWeeklyReportsEdit = "Academic-weeklyreport-edit",
  academicWeeklyReportsDelete = "Academic-weeklyreport-delete",
  academicWeeklyReportsView = "Academic-weeklyreport-show",
  academicMonthlyReportsListing = "Academic-monthlyreport-list",
  academicMonthlyReportsCreate = "Academic-monthlyreport-create",
  academicMonthlyReportsEdit = "Academic-monthlyreport-edit",
  academicMonthlyReportsDelete = "Academic-monthlyreport-delete",
  academicMonthlyReportsView = "Academic-monthlyreport-show",
  myAppsAcademicSessionListing = "Academics-session-listing",
  myAppsCreateAcademicSession = "Academics-AcademicSession-create",
  myAppsMyCoursesListing = "Academics-mycourse-listing",
  studentOdRequestsListing = "student-od-requests-list",
  studentOdRequestsCreate = "student-od-requests-create",
  studentOdRequestsApprove = "student-od-requests-approve",

  createCommonCoursesPools = "Academics-commonCoursesPool-create",
  commonCoursesPoolsListing = "Academics-commonCoursesPool-listing",
  allocateCourseRoomListing = "Academics-allocateCourseRoom-listing",
  academicGradeBookListing = "Academics-gradeBook-listing",
  academicGradeBookDetailsListing = "Academics-gradeBook-listing", //  add details pages permission when available
  academicMarkAttendance = "Academics-mark-attendance",
  academicMarkGroupAttendance = "Academics-mark-group-attendance",
  academicDownloadMarkedAttendance = "Academics-download-marked-attendance",
  academicDownloadDateWiseAttendanceReport = "Academics-download-date-wise-attendance-report",
  academicDownloadMarkedGroupAttendance = "Academics-download-marked-group-attendance",
  academicMarksManagement = "Academics-marks-management",
  unSubmitGradeBookResult = "Academics-gradeBook-un-submit-result",
  submitGradeBookResult = "Academics-gradeBook-submit-result",
  gradeBookViewChange = "Academics-gradeBook-view-changes",
  gradeBookViewDetails = "Academics-gradeBook-view-details",
  verifyGradeBookResult = "Academics-gradeBook-verify-result",
  UnVerifyGradeBookResult = "Academics-gradeBook-un-verify-result",
  UnApproveGradeBookResult = "Academics-gradeBook-un-approve-result",
  approveGradeBookResult = "Academics-gradeBook-approve-result",
  gradeBookDownloadCSV = "Academics-gradeBook-download-award-list",
  gradeBookDownloadAwardList = "Academics-gradeBook-download-award-list",
  consolidatedResultsListing = "Academics-consolidatedResults-list",
  submittedCoursesListing = "Academics-submittedCourses-list",
  financeAcademicSessionListing = "Academics-financeAcademicSession-list",
  semesterFeeVoucherListing = "Academic-Bulk-FeeVoucher",
  createFinanceAcademicSession = "Academics-financeAcademicSession-create",
  financeSessionStudentsListing = "finance-session-students-listing",
  approvedReceiptAcknowledgedListing = "Academics-Approved-and-Acknowledged-list",
  receiptAcknowledgedListing = "Exam-gradebook-acknowledged-list",
  appRecAckViewAwardList = "Academics-awardLists-view",
  appRecAppViewAwardList = "Academics-awardLists-approved-view",
  poolTeachersListing = "Academics-poolTeacher-list",
  enrollPoolTeacher = "enroll-pool-teacher",
  academicStudent = "Academics-student-list",
  academicStudentCreate = "Academics-student-create",
  academicStudentEdit = "Academics-student-edit",
  academicStudentDelete = "Academics-student-delete",
  academicStudentTranscripts = "Academics-student-transcripts",
  academicStudentEnrollment = "Academics-student-enrollment",
  academicStudentVouchers = "Academics-student-vouchers",
  academicStudentStatus = "Academics-student-status",
  academicStudentMigrated = "Academics-student-migrated",
  academicStudentFulfilmentReport = "Academics-student-fulfilment-report",
  academicStudentRetentionAdd = "Academics-student-retention-add",
  academicStudentDownloadPdf = "Academics-student-download-pdf",
  academicStudentDownloadExcel = "Academics-student-download-excel",
  academicStudentVerificationListing = "Academics-StudentVerification-Listing",
  academicStudentDownloadProgramChangeVoucher = "Academics-student-download-program-change-voucher",
  academicStudentDownloadSemesterFreezeVoucher = "Academics-student-download-semester-freeze-voucher",
  academicStudentDownloadTranscriptVoucher = "Academics-student-download-transcript-voucher",
  academicStudentProfileEdit = "Academics-studentProfile-edit",
  academicStudentProfileAuditView = "Academics-studentProfile-audit-view",
  verifyViewAwardList = "Academics-awardLists-verified-view",
  academicStudentDownloadAdmitCard = "Academics-student-download-admit-card",
  studentCardManagementListing = "Academics-Student-cards-list",
  studentCardManagementDownload = "Academics-Student-cards-download",
  studentsAdmitCardsListing = "Academics-Student-admit-cards-list",
  studentsAdmitCardsGenerate = "Academics-Student-admit-cards-generate",
  academicsConsolidatedResultsList = "Academics-consolidated-results-list",
  sectionCoursesListing = "Academics-consolidated-results-view-section",
  academicsConsolidatedResultsViewPostition = "Academics-consolidated-results-view-positions",
  academicsConsolidatedResultsDownloadAwardList = "Academics-consolidated-results-download-award-list",

  // SIR Permissions
  sirCategoryList = "sir-category-list",
  sirCategoryCreate = "sir-category-create",
  sirCategoryEdit = "sir-category-edit",
  sirCategoryDelete = "sir-category-delete",
  sirTypeList = "sir-type-list",
  sirTypeCreate = "sir-type-create",
  sirTypeEdit = "sir-type-edit",
  sirTypeDelete = "sir-type-delete",
  sirTypeFieldsListing = "sir-type-fields-listing",
  sirTypeFieldsCreate = "sir-type-fields-create",
  sirRequestList = "sir-request-list",
  sirRequestCreate = "sir-request-create",
  sirRequestShow = "sir-request-show",
  sirRequestEdit = "sir-request-edit",
  sirRequestDelete = "sir-request-delete",
  sirRequestTrack = "sir-request-track",
  sirRequestAction = "sir-request-action",

  studentDuplicateCardManagementListing = "duplicate-card-list",
  studentDuplicateCardManagementCreate = "duplicate-card-create",
  studentDuplicateCardManagementShow = "duplicate-card-show",
  studentDuplicateCardManagementDelete = "duplicate-card-delete",

  academicStudentFine = "Academics-studentFfine-list",
  academicDefaulterStudent = "Academics-defaulterStudents-list",
  academicFeeTypeListing = "Academics-feeType-list",
  createAcademicFeeType = "Academics-feeType-create",
  createAcademicFeePlan = "Academics-feePlans-create",
  academicFeePlansListing = "Academics-feePlans-list",
  createAcademicFeeQuota = "Academics-feeQuotas-create",
  academicFeeQuotasListing = "Academics-feeQuotas-list",
  academicStudentClearence = "Academics-student-clearence",
  academicManageExamIncharge = "Academics-ExamIncharge-show",
  academicExamIncharge = "Academics-ExamIncharge-list",
  academicExamInchargeCreate = "Academics-ExamIncharge-create",
  academicSectionRoomsListing = "Academics-SesctionRooms-list",
  manageGradeTemplates = "Academics-gradeTemplateLinkGrades-show",
  academicSyncGradeTemplates = "Academics-gradeTemplateSync-list",
  studentClearenceListing = "Academic-StudentClearence-Listing",
  createClearanceAuthority = "create-clearance-authority",
  clearanceAuthoritiesListing = "clearance-authorities-listing",
  createStudentStatus = "create-student-status",
  studentStatusListing = "student-status-listing",
  createStudentGroup = "create-student-group",
  studentGroupListing = "student-groups-listing",
  createStudentSpecialization = "create-student-specialization",
  studentSpecializationsListing = "student-specializations-listing",
  createAcademicSemesterType = "create-academic-semester-type",
  academicSemesterTypesListing = "academic-semester-types-listing",
  createAcademicLetterGrade = "Academics-letterGrades-create",
  academicLetterGradesListing = "Academics-letterGrades-list",

  academicTemplateCoursesCoReqListing = "Academics-TemplateCourses-co-req-list",
  academicTemplateCoursesCoReqCreate = "Academics-TemplateCourses-co-req-create",
  academicTemplateCoursesCoReqUpdate = "Academics-TemplateCourses-co-req-update",
  academicTemplateCoursesCoReqShow = "Academics-TemplateCourses-co-req-show",
  academicTemplateCoursesCoReqDelete = "Academics-TemplateCourses-co-req-delete",

  academicTemplateCoursesPreReqListing = "Academics-TemplateCourses-pre-req-list",
  academicTemplateCoursesPreReqCreate = "Academics-TemplateCourses-pre-req-create",
  academicTemplateCoursesPreReqShow = "Academics-TemplateCourses-pre-req-show",
  academicTemplateCoursesPreReqDelete = "Academics-TemplateCourses-pre-req-delete",
  academicTemplateCoursesPreReqUpdate = "Academics-TemplateCourses-pre-req-update",

  academicTemplateEqualentCourseList = "Academics-TemplateCourses-equivalent-list",
  academicTemplateEqualentCourseCreate = "Academics-TemplateCourses-equivalent-create",
  academicTemplateEqualentCourseUpdate = "Academics-TemplateCourses-equivalent-upfate",
  academicTemplateEqualentCourseShow = "Academics-TemplateCourses-equivalent-show",
  academicTemplateEqualentCourseDelete = "Academics-TemplateCourses-equivalent-delete",

  employeesMetaListing = "employees-meta-list",
  employeesMetaCreate = "employees-meta-create",
  employeesMetaUpdate = "employees-meta-edit",
  employeesMetaDelete = "employees-meta-delete",
  employeesMetaVeiw = "employees-meta-view",

  createAcademicSection = "Academics-sections-create",
  academicSectionsListing = "Academics-sections-listing",
  createAcademicTemplateCourse = "Academics-templateCourses-create",
  academicTemplateCoursesListing = "Academics-templateCourses-list",
  academicStudentViewProfile = "Academics-student-view-profile",
  academicStudentEditProfile = "Academics-student-edit-profile",
  obePeosListing = "Academics-obePeos-list",
  obePeosCreate = "Academics-obePeos-create",
  obePeosEdit = "Academics-obePeos-edit",
  obePeosDelete = "Academics-obePeos-delete",
  obePlosListing = "Academics-obePlos-list",
  obePlosCreate = "Academics-obePlos-create",
  obePlosEdit = "Academics-obePlos-edit",
  obePlosDelete = "Academics-obePlos-delete",
  obeKnowledgeProfilesListing = "Academics-obeKnowledgeProfiles-list",
  obeKnowledgeProfilesCreate = "Academics-obeKnowledgeProfiles-create",
  obeKnowledgeProfilesEdit = "Academics-obeKnowledgeProfiles-edit",
  obeKnowledgeProfilesDelete = "Academics-obeKnowledgeProfiles-delete",
  obeEngineeringCompetenciesListing = "Academics-obeEngineeringCompetencies-list",
  obeEngineeringCompetenciesCreate = "Academics-obeEngineeringCompetencies-create",
  obeEngineeringCompetenciesEdit = "Academics-obeEngineeringCompetencies-edit",
  obeEngineeringCompetenciesDelete = "Academics-obeEngineeringCompetencies-delete",
  obeClosListing = "Academics-obeClos-list",
  obeClosCreate = "Academics-obeClos-create",
  obeClosEdit = "Academics-obeClos-edit",
  obeClosDelete = "Academics-obeClos-delete",
  obePeoPloMappingShow = "Academic-obePeoPloMapping-show",
  obePeoPloMappingCreate = "Academic-obePeoPloMapping-create",
  obePeoPloMappingEdit = "Academic-obePeoPloMapping-edit",
  obePeoPloMappingDelete = "Academic-obePeoPloMapping-delete",
  obeCloPloMappingShow = "Academics-obeCloPloMapping-show",
  obeCloPloMappingCreate = "Academics-obeCloPloMapping-create",
  obeCloPloMappingEdit = "Academics-obeCloPloMapping-edit",
  obeCloPloMappingDelete = "Academics-obeCloPloMapping-delete",
  createAcademicInternship = "create-academic-internship",
  academicInternshipsListing = "academic-internships-listing",
  hrManagementLeaveDashboard = "leaves-dashboard",
  createOvertimeSlot = "create-overtime-slot",
  overtimeSlotsListing = "overtime-slots-listing",
  absentEmployeesListing = "absent-employees-listing",
  leaveCancellationListing = "leave-cancellation-listing",
  releasedLeaveBalancingReportListing = "released-leave-balancing-report-listing",
  academicManageFeePlanListing = "Academics-ManageFeePlan-List",
  academicFeeTransactionsListing = "Academics-feeTransaction-list",
  createAcademicFeeReceipt = "Academics-feeReceipt-create",
  academicPaidVouchersListing = "Academics-paidVouchers-list",
  academicExamTypeListing = "Academics-ExamType-list",
  createAcademicExamType = "Academics-ExamType-create",
  basarStudentRequestsListing = "Academics-basar-requests-list",
  academicCourseRepeatWorkflowListing = "Academics-course-repeat-workflow-list",
  basarSupervisorsListing = "Academics-basar-supervisors-list",
  basarSupervisorsCreate = "Academics-basar-supervisors-create",
  basarSupervisorsEdit = "Academics-basar-supervisors-edit",
  basarSupervisorsDelete = "Academics-basar-supervisors-delete",
  basarSupervisorsShow = "Academics-basar-supervisors-show",
  basarSupervisorProgramsListing = "Academics-basar-supervisors-programs-list",
  createAcademicExam = "Academics-Exam-create",
  academicExamsListing = "Academics-Exam-list",
  createAcademicInvigilator = "Academics-Invigilator-create",
  academicInvigilatorsListing = "Academics-Invigilator-list",
  createAcademicAuthority = "Academics-Authority-create",
  academicAuthorityListing = "Academics-Authority-List",
  createAcademicAuthorityUser = "Academics-AuthorityUser-create",
  academicAuthorityUsersListing = "Academics-AuthorityUser-list",
  createAcademicGradeTemplate = "Academics-gradeTemplate-create",
  academicGradeTemplatesListing = "Academics-gradeTemplate-list",
  createAcademicStatus = "Academics-AcademicStatus-create",
  academicStatusListing = "Academics-AcademicStatus-list",
  programAdvisorPrograms = "Academics-ProgramAdvisor-Mylist",
  gradeBookList = "Academics-course-gardebooks-list",

  academicExamInvigilatorsListing = "exam-invigilators-list",
  academicExamInvigilatorsCreate = "exam-invigilators-create",
  academicExamInvigilatorsDelete = "exam-invigilators-delete",
  academicExamInvigilatorsUpdate = "exam-invigilators-show",
  academicExamInvigilatorsEdit = "exam-invigilators-edit",
  academicExamRoomsListing = "exam-rooms-list",
  academicExamRoomsCreate = "exam-rooms-create",
  academicExamRoomsDelete = "exam-rooms-delete",
  academicExamRoomsUpdate = "exam-rooms-show",
  academicExamRoomsEdit = "exam-rooms-edit",
  academicExamProgramsListing = "exam-programs-list",
  academicExamProgramsCreate = "exam-programs-create",
  academicExamProgramsDelete = "exam-programs-delete",
  academicExamProgramsUpdate = "exam-programs-show",
  academicExamProgramsEdit = "exam-programs-edit",
  academicExamDaySlotsListing = "exam-exam-day-slots-list",
  academicExamDaySlotsCreate = "exam-exam-day-slots-create",
  academicExamDaySlotsDelete = "exam-exam-day-slots-delete",
  academicExamDaySlotsUpdate = "exam-exam-day-slots-show",
  academicExamDaySlotsEdit = "exam-exam-day-slots-edit",
  academicExamTimeSlotsListing = "exam-time-slots-list",
  academicExamTimeSlotsCreate = "exam-time-slots-create",
  academicExamTimeSlotsDelete = "exam-time-slots-delete",
  academicExamTimeSlotsUpdate = "exam-time-slots-show",
  academicExamTimeSlotsEdit = "exam-time-slots-edit",
  academicExamTimeSlotsRoomsAllocationListing = "exam-time-slot-room-allocations-list",
  academicExamTimeSlotsRoomsAllocationCreate = "exam-time-slot-room-allocations-create",
  academicExamTimeSlotsRoomsAllocationDelete = "exam-time-slot-room-allocations-delete",
  academicExamTimeSlotsRoomsAllocationUpdate = "exam-time-slot-room-allocations-show",
  academicExamTimeSlotsRoomsAllocationEdit = "exam-time-slot-room-allocations-edit",
  academicTimeSlotsListing = "time-slots-list",
  academicTimeSlotsCreate = "time-slots-create",
  academicTimeSlotsDelete = "time-slots-delete",
  academicTimeSlotsUpdate = "time-slots-show",
  academicTimeSlotsEdit = "time-slots-edit",
  academicExamsResultListing = "Academic-exam-result-list",
  academicExamsResultCreate = "Academic-exam-result-create",
  academicExamsResultsUpdate = "Academic-exam-result-show",
  academicExamsResultsEdit = "Academic-exam-result-edit",

  remunerationListing = "HR-Remuneration-list",
  overtimeManualEntryListing = "HR-OverTime-ManualEntry-list",
  remunerationSettingsListing = "HR-Remuneration-settings",
  employeesOvertimeListing = "HR-EmployeesOvertime-list",

  teachersListing = "Teacher-list",
  teachersCreate = "Teacher-create",
  teachersView = "Teacher-list",
  teachersDelete = "Teacher-delete",
  teachersUpdate = "Teacher-update",

  employeesListing = "HR-Employees-list",
  employeesCreate = "HR-Employees-create",
  employeesView = "HR-Employees-show",
  employeesDelete = "HR-Employees-delete",
  employeesUpdate = "HR-Employees-edit",
  employeesDownloadPDF = "HR-Employees-download-pdf",
  employeesDownloadExcel = "HR-Employees-download-excel",

  requestedLeavesListing = "HR-RequestedLeaves-list",
  employeesAttendanceListing = "HR-Attendance-list",
  subordinateAttendanceListing = "HR-Attendance-subordinates-list",
  myAttendanceListing = "HR-Attendance-my-list",
  employeesSalaryListing = "HR-Attendance-list", // pls add permission actual for this module

  createLeaveRequestion = "HR-LeaveRequistion-create",
  leaveTypeListing = "HR-LeaveTypes-list",
  createLeaveTypes = "HR-LeaveTypes-create",
  setOffDays = "HR-Set-OffDays",
  requestDetails = "HR-LeaveLedger-Request-details",
  academicPlanofStudies = "Academics-PlanOfStudies-List",
  createStudyPlans = "Academics-PlanOfStudies-create",
  downloadPlanofStudies = "Academics-PlanOfStudies-download-pdf",
  createAcademicSession = "Academics-AcademicSession-create",
  planOfStudyCourseListing = "Academics-PlanOfStudiesCourses-List",
  planOfStudyCourseListingOld = "Academics-PlanOfStudiesCourses-List",
  addStudentsToPlanOfStudy = "Academics-PlanOfStudyStudents-create",
  planOfStudyStudentListing = "Academics-PlanOfStudyStudents-List",
  deletePlanOfStudyStudents = "Academics-PlanOfStudyStudents-delete",
  viewAcademicStatus = "Academics-AcademicStatus-show",
  deleteAcademicStatus = "Academics-AcademicStatus-delete",
  editAcademicStatus = "Academics-AcademicStatus-edit",
  downloadAcademicStatusPDF = "Academics-AcademicStatus-download-pdf",
  downloadAcademicStatusExcel = "Academics-AcademicStatus-download-excel",
  deleteUserByAdmin = "Users-system-users-delete",
  updateUserPassword = "admin-change-user-password",
  updateempUserPassword = "employee-change-user-password",
  EditAuthorityMemberType = "Authorities-MemberType-edit",
  DeleteAuthorityMemberType = "Authorities-MemberType-delete",
  EditAuthorityCommitteeType = "Authorities-CommitteeType-edit",
  DeleteAuthorityCommitteeType = "Authorities-CommitteeType-delete",
  hrManagementLeavesLedgerListing = "hrm-leaves-ledger-listing",
  UpdateAuthorityNotification = "Authorities-CouncilNotification-edit",
  DeleteAuthorityNotification = "Authorities-CouncilNotification-delete",
  editAuthority = "Authorities-edit",
  deleteAuthority = "Authorities-delete",
  deleteSenateMeeting = "Authorities-SenataMeetings-delete",
  editSenateMeeting = "Authorities-SenataMeetings-edit",
  createAuthorityBoard = "Authorities-boards-create",
  authorityBoardsListing = "Authorities-boards-list",
  createTeachersTitle = "Academics-create-teachers-title",
  teachersTitlesListing = "Academics-teachers-titles-listing",
  createCourseType = "Academics-create-course-type",
  courseTypesListing = "Academics-course-types-listing",
  teacherCourseTypesListing = "Academics-teacher-course-types-listing",
  createTeacherCourseType = "Academics-teacher-course-type-create",
  editAuthorityBoard = "Authorities-boards-edit",
  deleteAuthorityBoard = "Authorities-boards-delete",
  setHolidaysListing = "HR-Set-Holidays",
  studentPortalNoticeBoard = "StudentPortal-NoticeBoard",
  studentPortalDocumentsListing = "StudentPortal-Mylinks-documents-list",
  activitiesAndEventListing = "activities-and-events-list",
  activitiesAndEventCreate = "activities-and-events-create",
  activitiesAndEventEdit = "activities-and-events-edit",
  activitiesAndEventDelete = "activities-and-events-delete",
  activitiesAndEventShow = "activities-and-events-show",
  newsAndEventsListing = "news-and-events-list",
  newsAndEventsCreate = "news-and-events-create",
  newsAndEventsEdit = "news-and-events-edit",
  newsAndEventsDelete = "news-and-events-delete",
  newsAndEventsView = "news-and-events-show",

  // Communications (Calendar / Events)
  communicationsCalendarFeedView = "communications-calendar-feed-view",
  communicationsCalendarsView = "communications-calendars-view",
  communicationsCalendarsCreate = "communications-calendars-create",
  communicationsCalendarsEdit = "communications-calendars-edit",
  communicationsCalendarsDelete = "communications-calendars-delete",
  communicationsEventsView = "communications-events-view",
  communicationsEventsCreate = "communications-events-create",
  communicationsEventsEdit = "communications-events-edit",
  communicationsEventsDelete = "communications-events-delete",
  communicationsEventsApprove = "communications-events-approve",
  communicationsEventsPublish = "communications-events-publish",
  communicationsEventsArchive = "communications-events-archive",
  communicationsNewsListing = "communications-news-view",
  communicationsNewsCreate = "communications-news-create",
  communicationsNewsEdit = "communications-news-edit",
  communicationsNewsDelete = "communications-news-delete",
  communicationsNewsPublish = "communications-news-publish",
  communicationsAnnouncementsListing = "communications-announcements-view",
  communicationsAnnouncementsCreate = "communications-announcements-create",
  communicationsAnnouncementsEdit = "communications-announcements-edit",
  communicationsAnnouncementsDelete = "communications-announcements-delete",
  communicationsAnnouncementsPublish = "communications-announcements-publish",
  communicationsDispatchesView = "communications-dispatches-view",
  communicationsDispatchesCreate = "communications-dispatches-create",
  communicationsAnalyticsView = "communications-analytics-view",

  duplicateStudentCardReq = "duplicate-card-management",
  duplicateCardApply = "duplicate-card-apply",

  studentPortalProfile = "StudentPortal-Mylinks-profile",
  studentPortalLMS = "StudentPortal-LMS-list",
  studentPortalLibraryBooks = "StudentPortal-LibraryBooks-list",
  studentPortalSupportTickets = "StudentPortal-SupportTickets-list",
  studentDashboard = "StudentPortal-dashboard",

  academicsStudentFeePlan = "FeePlan-list",
  academicsStudentFeePlanShow = "FeePlan-show",
  academicsStudentFeePlanPdf = "FeePlan-download-pdf",
  academicsStudentFeePlanExcel = "FeePlan-download-excel",

  campaignProgramsListing = "AdmissionCampaigns-Programs-List",
  createSetHolidays = "HR-Set-Holidays-create",

  studentPortalSupportTicketsListing = "student-support-tickets-listing",
  createStudentPortalSupportTicket = "StudentPortal-SupportTickets-create",
  academicsCurrentEnrollment = "StudentPortal-Academics-CurrentEnrollment",
  academicsStudentPlanOfStudies = "StudentPortal-Academics-PlanOfStudy-list",
  academicsStudentTranscript = "StudentPortal-Academics-Transcript",
  academicFinancialVouchers = "StudentPortal-Academics-FinancialVouchers-list",
  // academicAccountStatements = "StudentPortal-Academics-AccountStatement-list",
  academicHolidaysList = "StudentPortal-Academics-Holidays-list",
  academicStudentClearance = "StudentPortal-Academics-MyClearance",
  studentLMSMyFiles = "StudentPortal-LMS-MyFiles",
  studentAssignments = "StudentPortal-LMS-assignments-list",
  studentCourseMaterial = "StudentPortal-LMS-courseMaterial-list",
  studentVehicalEntryListing = "StudentPortal-Vehicle-Entry-Application-list",
  createStudentVehicleEntry = "StudentPortal-Vehicle-Entry-Application-create",
  studentTransportScheduleList = "StudentPortal-Transport-Schedule-list",
  studentAcademicCourseChallan = "course-repeat-challan",
  courseRepeatRequestListing = "StudentPortal-Academics-CourseRepeatRequest",
  admissionLockedMeritListing = "Admission-Locked-MeritList-list",
  downloadAdmissionLockedMeritExcel = "Admission-Locked-MeritList-download-excel",
  downloadAdmissionLockedMeritPDF = "Admission-Locked-MeritList-download-pdf",
  extendAdmissionLockedMeritDate = "Admission-Locked-MeritList-extend-date",
  registerAdmissionLockedMeritStudent = "Admission-Locked-MeritList-register-student",
  reconsiderAdmissionLockedMerit = "Admission-Locked-MeritList-reconsider",
  downloadAdmissionLockedMeritFeeChallan = "Admission-Locked-MeritList-download-admission-fee-challan",
  downloadAdmissionLockedMeritHostelVoucher = "Admission-Locked-MeritList-download-hostel-voucher",
  downloadAdmissionLockedMeritApplication = "Admission-Locked-MeritList-download-application",
  downloadAdmissionLockedMeritOfferLetter = "Admission-Locked-MeritList-download-offer-letter",
  sendAdmissionLockedMeritMail = "Admission-Locked-MeritList-send-mail",
  sendAdmissionLockedMeritSms = "Admission-Locked-MeritList-send-sms",
  sendAdmissionLockedMeritWhatsapp = "Admission-Locked-MeritList-send-whatsapp",
  bulkActionsAdmissionLockedMerit = "Admission-Locked-MeritList-bulk-actions",
  admissionReconsiderListing = "Admission-Reconsider-list",
  academicProgramSpecializationListing = "Academics-ProgramSpecialization-listing",
  academicCreateProgramSpecialization = "Academics-ProgramSpecialization-create",
  academicManageSpecializationListing = "Academics-ManageSpecialization-listing",
  academicCreateManageSpecialization = "Academics-ManageSpecialization-create",
  academicManageStudentListing = "Academics-ManageStudentSpecialization-listing",
  academicCreateManageStudent = "Academics-ManageStudentSpecialization-listing",
  academicAppliedSpecialization = "Academics-AppliedProgramSpecialization-listing",
  organizationAdminListing = "Organization-AdminListing",
  createOrganizationAdmin = "Organization-AdminCreate",
  updateOrganizationAdmin = "Organization-OrgAdminUpdate",
  resultSettingTemplateListing = "Academics-ResultSettingTemplateList",
  createResultSettingTemplateListing = "Academics-ResultSettingTemplateCreate",
  templateHeaderListing = "Academics-ResultSettingTemplateHeaderList",
  createTemplateHeader = "Academics-ResultSettingTemplateHeaderCreate",
  orgAdminListing = "organizations-admin-listing",
  admissionDashboard = "Admission-AdmissionDashboard",
  dssReferralsDashboard = "dashboard-referrals",
  agencyDashboard = "agency-dashboard",
  nonDegreeProgramsDashboard = "Admission-AdmissionDashboard",
  careerDashboard = "career-dashboard",
  enrollmentDashboard = "Admission-enrollments-dashboard",
  editEPStudentProfile = "eportal-profile-edit",
  viewEPStudentProfile = "eportal-profile-view",
  examinationDashboard = "Academics-dashboard-examination",

  // student scholaship permissions
  studentScholarshipListing = "scholarship-list-student",
  studentScholarshipApply = "scholarship-apply",
  studentScholarshipAppliedListing = "scholarship-applied-list",
  studentScholarshipProfile = "scholarship-applicant-profile",
  studentScholarshipProfileMeter = "scholarship-applicant-profile-meter",
  studentScholarshipProfileUpdateBasicInfo = "scholarship-applicant-profile-update-basic-info",
  studentScholarshipProfileUpdateAccommodationInfo = "scholarship-applicant-profile-update-accommodation-info",

  studentScholarshipFamilyMembersList = "scholarship-applicant-family-members-list",
  studentScholarshipFamilyMembersCreate = "scholarship-applicant-family-members-create",
  studentScholarshipFamilyMembersEdit = "scholarship-applicant-family-members-edit",
  studentScholarshipFamilyMembersShow = "scholarship-applicant-family-members-show",
  studentScholarshipFamilyMembersDelete = "scholarship-applicant-family-members-delete",

  studentScholarshipMonthlyIncomeList = "scholarship-applicant-monthly-income-list",
  studentScholarshipMonthlyIncomeCreate = "scholarship-applicant-monthly-income-create",
  studentScholarshipMonthlyIncomeShow = "scholarship-applicant-monthly-income-show",
  studentScholarshipMonthlyIncomeEdit = "scholarship-applicant-monthly-income-edit",
  studentScholarshipMonthlyIncomeDelete = "scholarship-applicant-monthly-income-delete",

  studentScholarshipMonthlyExpenseList = "scholarship-applicant-monthly-expense-list",
  studentScholarshipMonthlyExpenseCreate = "scholarship-applicant-monthly-expense-create",
  studentScholarshipMonthlyExpenseEdit = "scholarship-applicant-monthly-expense-edit",
  studentScholarshipMonthlyExpenseDelete = "scholarship-applicant-monthly-expense-delete",
  studentScholarshipMonthlyExpenseShow = "scholarship-applicant-monthly-expense-show",

  studentScholarshipFamilyAssetsList = "scholarship-applicant-family-assets-list",
  studentScholarshipFamilyAssetsCreate = "scholarship-applicant-family-assets-create",
  studentScholarshipFamilyAssetsEdit = "scholarship-applicant-family-assets-edit",
  studentScholarshipFamilyAssetsShow = "scholarship-applicant-family-assets-show",
  studentScholarshipFamilyAssetsDelete = "scholarship-applicant-family-assets-delete",

  loginAsStudentByAdmin = "admin-login-as-student",
  loginAsAdminByAdmin = "admin-login-as-employee",
  changeAdminPasswordByAdmin = "admin-change-employee-password",
  changeStudentPasswordByAdmin = "admin-change-student-password",

  loginAsStudentAdmissionApplication = "StudentApplications-loginas",
  editStudentAdmissionApplication = "StudentApplications-update",
  callStudentAdmissionApplication = "StudentApplications-view-phone",
  messageStudentAdmissionApplication = "StudentApplications-view-email",
  emailTemplateListing = "EmailTemplate-list",
  emailTemplateCreate = "EmailTemplate-create",
  emailTemplateEdit = "EmailTemplate-update",
  emailTemplateDelete = "EmailTemplate-delete",
  emailTemplateKeyListing = "EmailTemplateKey-list",
  emailTemplateKeyCreate = "EmailTemplateKey-create",
  emailTemplateKeyEdit = "EmailTemplateKey-update",
  emailTemplateKeyDelete = "EmailTemplateKey-delete",
  academicVirtualCoursesListing = "virtual-courses-listing",
  shiftProfileListing = "shift-profile-listing",
  createShiftProfile = "create-shift-profile",
  roomToSectionProfileListng = "room-to-section-profile-listing",
  createRoomToSectionProfile = "create-room-to-section-profile",
  roomToCourseProfileListing = "/private/time-table/room-to-course-profile/listing",
  createRoomToCourseProfile = "/private/time-table/room-to-course-profile/create",
  academicsDashboard = "Academics-Dashboard",
  facultyWorkloadDashboard = "Academics-FacultyWorkload-Dashboard",
  defaultCreditHoursCreate = "CreaditHours-Management-Create",
  defaultCreditHoursUpadate = "CreaditHours-Management-Update",
  defaultCreditHoursListing = "CreaditHours-Management-List",
  defaultCreditHourShow = "CreaditHours-Management-Show",
  timeTableYearMapListing = "TimeTable-year-map-listing",
  timeTableFetFileGenerator = "TimeTable-fet-file-generator",
  timeTableListing = "TimeTable-list",
  viewTimeTable = "TimeTable-view",
  timeTableCreate = "TimeTable-create",
  timeTableUpdate = "TimeTable-update",
  timeTableDelete = "TimeTable-delete",
  timeTableDurationListing = "TimeTable-durations-list",
  timeTableDurationCreate = "TimeTable-durations-create",
  timeTableDurationEdit = "TimeTable-durations-edit",
  timeTableDurationDelete = "TimeTable-durations-delete",

  timeTableActivityListing = "TimeTable-activities-list",
  timeTableActivityCreate = "TimeTable-activities-create",
  timeTableActivityEdit = "TimeTable-activities-edit",
  timeTableActivityDelete = "TimeTable-activities-delete",
  academicSessionAddTimetable = "academic-session-add-timetable",
  academicCourseAddTimetable = "academic-course-add-timetable",

  timeTablePlannerListing = "TimeTable-Planner-list",
  timeTablePlannerCreate = "TimeTable-Planner-create",
  timeTablePlannerUpdate = "TimeTable-Planner-update",
  timeTablePlannerDelete = "TimeTable-Planner-delete",
  timeTablePlannerDashboard = "TimeTable-Planner-list",
  prefferedRoomCourseListing = "Preffered_Room-courses-list",
  prefferedRoomCourseListCreate = "Preffered_Room-courses-create",
  prefferedRoomCourseListEdit = "Preffered_Room-courses-edit",
  prefferedRoomCourseListDelete = "Preffered_Room-courses-delete",
  roomToSectionListing = "Preffered_Room-section-list",
  roomToSectionCreate = "Preffered_Room-section-create",
  roomToSectionUpdate = "Preffered_Room-section-update",
  roomToSectionDelete = "Preffered_Room-section-delete",
  roomToSectionShow = "Preffered_Room-section-show",
  myEnrollments = "Student-Course-Enrollments",
  downloadCourseMaterial = "study-material-list",
  courseMaterialList = "study-material-download",
  studentPlanOfStudy = "Student-Plan-Of-Study",
  studentTranscript = "Student-Transcript",

  studentAccountStatement = "StudentPortal-Academics-AccountStatement-list",
  studentFinancialVouchers = "StudentPortal-Academics-FinancialVouchers-list",
  studentMyWallet = "StudentPortal-Academics-MyWallet-list",
  studentMyWalletPay = "StudentPortal-Academics-MyWallet-pay",

  myClearanceListing = "StudentPortal-Academics-MyClearance",
  studentHolidayList = "student-holiday-list",
  generateCourseChallan = "generate-course-challan",
  ticketListing = "StudentPortal-SupportTickets-list",
  createTicket = "StudentPortal-SupportTickets-create",
  incomeManagementDashboard = "Finance-finance-dashboard",

  breakTimeManagementListing = "Break-Time-Management-list",
  breakTimeManagementCreate = "Break-Time-Management-create",
  breakTimeManagementEdit = "Break-Time-Management-edit",
  breakTimeManagementShow = "Break-Time-Management-show",
  breakTimeManagementDelete = "Break-Time-Management-delete",
  constrainsManagementListing = "Constrains-Management-list",
  a1 = "Constrains-Management-create", // add name to permissions as needed  these permission added from backend but not used in fe
  a2 = "Constrains-Management-edit",
  a3 = "Constrains-Management-show",
  a4 = "Constrains-Management-delete",
  a5 = "view-sections-list",
  a6 = "view-sections-create",
  a7 = "view-sections-edit",
  a8 = "view-sections-show",
  a9 = "view-sections-delete",
  a0 = "Assign-sections-list",
  a11 = "Assign-sections-create",
  a12 = "Assign-sections-edit",
  a14 = "Assign-sections-show",
  a15 = "Assign-sections-delete",
  a16 = "Generate_FET-File",
  a17 = "Execute_FET-File",
  a18 = "Download-course-File",
  academicsVerifiedGradebookListing = "Academics-verified-gradebook-listing",

  academicsAwardList = "Academics-award-list",
  financeStudentVouchersListing = "Finance-student-voucher-listing",

  newsManagementsListing = "Manage-News-list",
  newsManagementsCreate = "Manage-News-create",
  newsManagementsUpdate = "Manage-News-edit",
  newsManagementsDelete = "Manage-News-delete",
  newsManagementsView = "Manage-News-show ",
  newsManagementsDownloadPDF = "Manage-News-download-pdf",
  newsManagementsDownloadExcel = "Manage-News-download-excel",

  newsAudienceListing = "News-audience-list",
  newsAudienceCreate = "News-audience-create",
  newsAudienceUpdate = "News-audience-edit",
  newsAudienceDelete = "News-audience-delete",
  newsAudienceView = "News-audience-show ",
  newsAudienceDownloadPDF = "News-audience-download-pdf",
  newsAudienceDownloadExcel = "News-audience-download-excel",

  // ------------------                            ----------------------
  // ------------------  Admin_Profile_Permission  ----------------------
  // ------------------                            ----------------------

  myProfileAdminAttendanceList = "employee-profile-show",
  myAppsInitiateLeave = "employee-profile-show",
  myAppsAttendanceRequest = "employee-profile-show",
  myProfileAdminSalaryList = "employee-profile-show",

  myProfileAdminList = "employee-profile-show",
  myProfileAdminEdit = "employee-profile-edit",
  myProfileAdminCreate = "employee-profile-edit",

  adminQualificationList = "employee-qualification-list",
  adminQualificationCreate = "employee-qualification-add",
  adminQualificationEdit = "employee-qualification-edit",
  adminQualificationShow = "employee-qualification-show",
  adminQualificationDelete = "employee-qualification-delete",
  adminQualificationDownloadDocument = "employee-qualification-download-document",

  adminEmployeementsCreate = "employee-work-experience-add",
  adminEmployeementsList = "employee-work-experience-list",
  adminEmployeementsEdit = "employee-work-experience-edit",
  adminEmployeementsDelete = "employee-work-experience-delete",

  adminPublicationsCreate = "employee-research-publications-add",
  adminPublicationsList = "employee-research-publications-list",
  adminPublicationsEdit = "employee-research-publications-edit",
  adminPublicationsDelete = "employee-research-publications-delete",

  adminProfessionalActivityCreate = "employee-professional-activities-add",
  adminProfessionalActivityList = "employee-professional-activities-list",
  adminProfessionalActivityEdit = "employee-professional-activities-edit",
  adminProfessionalActivityDelete = "employee-professional-activities-delete",

  adminRandDCreate = "employee-research-projects-add",
  adminRandDList = "employee-research-projects-list",
  adminRandDEdit = "employee-research-projects-edit",
  adminRandDDelete = "employee-research-projects-delete",

  addmissionShortCoursesListing = "short-courses-list",
  addmissionShortCoursesCreate = "short-courses-create",
  addmissionShortCoursesEdit = "short-courses-edit",
  addmissionShortCoursesDelete = "short-courses-delete",
  addmissionShortCoursesShow = "short-courses-delete",
  addmissionShortCoursesPollListing = "short-courses-poll-list",
  addmissionShortCoursesPollCreate = "short-courses-poll-create",
  addmissionShortCoursesPollEdit = "short-courses-poll-edit",
  addmissionShortCoursesPollDelete = "short-courses-poll-delete",
  addmissionShortCoursesPollShow = "short-courses-poll-delete",
  addmissionShortCoursesEnrollmentsListing = "short-courses-enrollments-list",
  addmissionShortCoursesEnrollmentsCreate = "short-courses-enrollments-create",
  addmissionShortCoursesApplicationsListing = "short-courses-applications-list",

  // scholarship module
  scholarshipListing = "scholarship-list",
  scholarshipCreate = "scholarship-create",
  scholarshipUpdate = "scholarship-edit",
  scholarshipDelete = "scholarship-delete",
  scholarshipShow = "scholarship-show",
  scholarShipStatusListing = "scholarship-status-list",
  scholarShipStatusCreate = "scholarship-status-create",
  scholarShipStatusUpdate = "scholarship-status-edit",
  scholarShipStatusDelete = "scholarship-status-delete",
  scholarShipStatusShow = "scholarship-status-show",
  scholarShipPhasesListing = "scholarship-phases-list",
  scholarShipPhasesCreate = "scholarship-phases-create",
  scholarShipPhasesUpdate = "scholarship-phases-edit",
  scholarShipPhasesDelete = "scholarship-phases-delete",
  scholarShipPhasesShow = "scholarship-phases-show",
  scholarShipTypesListing = "scholarship-types-list",
  scholarShipTypesCreate = "scholarship-types-create",
  scholarShipTypesUpdate = "scholarship-types-edit",
  scholarShipTypesDelete = "scholarship-types-delete",
  scholarShipTypesShow = "scholarship-types-show",
  scholarShipAmountTypeListing = "scholarship-amount-type-list",
  scholarShipAmountTypeCreate = "scholarship-amount-types-create",
  scholarShipAmountTypeUpdate = "scholarship-amount-types-edit",
  scholarShipAmountTypeDelete = "scholarship-amount-types-delete",
  scholarShipAmountTypeShow = "scholarship-amount-types-show",
  scholarShipOrganizationListing = "scholarship-organization-list",
  scholarShipOrganizationCreate = "scholarship-organization-create",
  scholarShipOrganizationUpdate = "scholarship-organization-edit",
  scholarShipOrganizationDelete = "scholarship-organization-delete",
  scholarShipOrganizationShow = "scholarship-organization-show",
  scholarshipScrutinyCommitteeListing = "scholarship-scrutiny-committee-list",
  scholarshipScrutinyCommitteeCreate = "scholarship-scrutiny-committee-create",
  scholarshipScrutinyCommitteeUpdate = "scholarship-scrutiny-committee-edit",
  scholarshipScrutinyCommitteeDelete = "scholarship-scrutiny-committee-delete",
  scholarshipApplicationsListing = "scholarship-applications-list",
  scholarshipApplicationsShow = "scholarship-applications-show",
  scholarshipApplicationsEdit = "scholarship-applications-edit",
  scholarshipScrutinyListing = "scholarship-scrutiny-list",
  scholarshipScrutinyCreate = "scholarship-scrutiny-create",
  scholarshipScrutinyUpdate = "scholarship-scrutiny-edit",
  scholarshipScrutinyDelete = "scholarship-scrutiny-delete",
  scholarshipGrantListing = "scholarship-grant-list",
  scholarshipGrantCreate = "scholarship-grant-create",
  scholarshipGrantUpdate = "scholarship-grant-edit",
  scholarshipGrantDelete = "scholarship-grant-delete",
  scholarshipPaymentListing = "scholarship-payment-list",
  scholarshipPaymentCreate = "scholarship-payment-create",
  scholarshipPaymentUpdate = "scholarship-payment-edit",
  scholarshipPaymentDelete = "scholarship-payment-delete",

  // Notifications
  notificationsList = "Notifications-list",
  myNotificationsList = "Notifications-my-notifications",
  myAppsMyReferrals = "my-referrals-list",
  notificationsCreate = "Notifications-create",
  notificationsEdit = "Notifications-edit",
  notificationsShow = "Notifications-show",
  notificationsDelete = "Notifications-delete",
  programAdvisorsListing = "Academics-ProgramAdvisor-list",
  programAdvisorsCreate = "Academics-ProgramAdvisor-create",
  programAdvisorsEdit = "Academics-ProgramAdvisor-edit",
  programAdvisorsDelete = "Academics-ProgramAdvisor-delete",

  academicsSettingsSelfEnrollments = "Academics-Settings-SelfEnrollments",
  academicsSettingsObe = "Academics-Settings-OBE",
  academicsSettingsCourseRepeatFee = "Academics-Settings-CourseRepeatFee",
  academicsSettingsCourseRepeatPolicy = "Academics-Settings-CourseRepeatPolicy",
  academicsSettingsCreditHourPolicy = "Academics-Settings-CreditHourPolicy",
  assessmentCategoriesListing = "Academics-AssessmentCategories-list",
  createAssessmentCategory = "Academics-AssessmentCategories-create",
  editAssessmentCategory = "Academics-AssessmentCategories-edit",
  deleteAssessmentCategory = "Academics-AssessmentCategories-delete",
  assessmentActivitiesListing = "Academics-AssessmentActivities-list", // Permission for listing activities
  createAssessmentActivity = "Academics-AssessmentActivities-create",
  editAssessmentActivity = "Academics-AssessmentActivities-edit",
  deleteAssessmentActivity = "Academics-AssessmentActivities-delete",
  obeLessonPlanListing = "Academics-obeLessonPlan-list",
  obeLessonPlanCreate = "Academics-obeLessonPlan-create",
  obeLessonPlanEdit = "Academics-obeLessonPlan-edit",
  obeLessonPlanDelete = "Academics-obeLessonPlan-delete",
  creditHourPolicyOverride = "credit-hour-policy-override",

  plannerDaysListing = "TimeTable-PlannerDays-list",
  plannerDaysCreate = "TimeTable-PlannerDays-create",
  plannerDaysEdit = "TimeTable-PlannerDays-edit",
  plannerDaysDelete = "TimeTable-PlannerDays-delete",

  plannerTimeSlotsListing = "TimeTable-PlannerTimeSlots-list",
  plannerTimeSlotsCreate = "TimeTable-PlannerTimeSlots-create",
  plannerTimeSlotsEdit = "TimeTable-PlannerTimeSlots-edit",
  plannerTimeSlotsDelete = "TimeTable-PlannerTimeSlots-delete",

  courseRoomAllocationsListing = "course-room-allocations",
  programManageAdvisors = "program-manage-advisors",

  // Transport Module Permissions
  vehicleTypesListing = "VehicleTypes-list",
  createVehicleType = "VehicleTypes-create",
  vehicleTypesShow = "VehicleTypes-show",
  vehicleTypesEdit = "VehicleTypes-edit",
  vehicleTypesDelete = "VehicleTypes-delete",

  vehiclesListing = "vehicles-list",
  createVehicle = "vehicles-create",
  vehiclesShow = "vehicles-show",
  vehiclesEdit = "vehicles-edit",
  vehiclesDelete = "vehicles-delete",

  transportStaffListing = "TransportStaff-list",
  createTransportStaff = "TransportStaff-create",
  transportStaffShow = "TransportStaff-show",
  transportStaffEdit = "TransportStaff-edit",
  transportStaffDelete = "TransportStaff-delete",

  stopsListing = "Stops-list",
  createStop = "Stops-create",
  stopsShow = "Stops-show",
  stopsEdit = "Stops-edit",
  stopsDelete = "Stops-delete",

  routesListing = "Routes-list",
  createRoute = "Routes-create",
  routesShow = "Routes-show",
  routesEdit = "Routes-edit",
  routesDelete = "Routes-delete",

  subRoutesListing = "SubRoutes-list",
  createSubRoute = "SubRoutes-create",
  subRoutesShow = "SubRoutes-show",
  subRoutesEdit = "SubRoutes-edit",
  subRoutesDelete = "SubRoutes-delete",
  subRoutesManageStops = "SubRoutes-manage-stops",

  transportAssignmentsListing = "TransportAssignments-list",
  createTransportAssignment = "TransportAssignments-create",
  transportAssignmentsShow = "TransportAssignments-show",
  transportAssignmentsEdit = "TransportAssignments-edit",
  transportAssignmentsDelete = "TransportAssignments-delete",
  studentScanAttendance = "StudentPortal-Academics-scan-attendance",
  studentMyAttendance = "StudentPortal-Academics-my-attendance",

  // Student Affairs Module Permissions
  studentAffairsDashboard = "student-affairs-dashboard",
  tenureListing = "tenures-list",
  createTenure = "tenures-create",
  editTenure = "tenures-edit",
  deleteTenure = "tenures-delete",
  viewTenure = "tenures-show",

  levelListing = "levels-list",
  createLevel = "levels-create",
  editLevel = "levels-edit",
  deleteLevel = "levels-delete",
  viewLevel = "levels-show",

  memberTypeListing = "member-types-list",
  createMemberType = "member-types-create",
  editMemberType = "member-types-edit",
  deleteMemberType = "member-types-delete",
  viewMemberType = "member-types-show",

  skillListing = "skills-list",
  createSkill = "skills-create",
  editSkill = "skills-edit",
  deleteSkill = "skills-delete",
  viewSkill = "skills-show",

  societyListing = "societies-list",
  createSociety = "societies-create",
  editSociety = "societies-edit",
  deleteSociety = "societies-delete",
  viewSociety = "societies-show",

  appStatusListing = "app-statuses-list",
  createAppStatus = "app-statuses-create",
  editAppStatus = "app-statuses-edit",
  deleteAppStatus = "app-statuses-delete",
  viewAppStatus = "app-statuses-show",

  bodyListing = "bodies-list",
  createBody = "bodies-create",
  editBody = "bodies-edit",
  deleteBody = "bodies-delete",
  viewBody = "bodies-show",

  eventTypeListing = "event-types-list",
  createEventType = "event-types-create",
  editEventType = "event-types-edit",
  deleteEventType = "event-types-delete",
  viewEventType = "event-types-show",

  eventVenueListing = "event-venues-list",
  createEventVenue = "event-venues-create",
  editEventVenue = "event-venues-edit",
  deleteEventVenue = "event-venues-delete",
  viewEventVenue = "event-venues-show",

  eventOrganizerListing = "event-organizers-list",
  createEventOrganizer = "event-organizers-create",
  editEventOrganizer = "event-organizers-edit",
  deleteEventOrganizer = "event-organizers-delete",
  viewEventOrganizer = "event-organizers-show",

  eventFundingListing = "event-fundings-list",
  createEventFunding = "event-fundings-create",
  editEventFunding = "event-fundings-edit",
  deleteEventFunding = "event-fundings-delete",
  viewEventFunding = "event-fundings-show",

  competitionTypeListing = "competition-types-list",
  createCompetitionType = "competition-types-create",
  editCompetitionType = "competition-types-edit",
  deleteCompetitionType = "competition-types-delete",
  viewCompetitionType = "competition-types-show",

  competitionLevelListing = "competition-levels-list",
  createCompetitionLevel = "competition-levels-create",
  editCompetitionLevel = "competition-levels-edit",
  deleteCompetitionLevel = "competition-levels-delete",
  viewCompetitionLevel = "competition-levels-show",

  externalParticipantListing = "external-participants-list",
  createExternalParticipant = "external-participants-create",
  editExternalParticipant = "external-participants-edit",
  deleteExternalParticipant = "external-participants-delete",
  viewExternalParticipant = "external-participants-show",

  societyEventListing = "society-events-list",
  createSocietyEvent = "society-events-create",
  editSocietyEvent = "society-events-edit",
  deleteSocietyEvent = "society-events-delete",
  viewSocietyEvent = "society-events-show",
  activeSocietiesList = "active-societies-list",
  applySocietyCreate = "apply-society-create",
  societyApplicationListing = "applications-list",
  societyApplicationEdit = "applications-edit",
  societyApplicationDelete = "applications-delete",
  societyApplicationView = "applications-show",
  universityEventApplicantsListing = "university-event-applicants-list",

  // APER permissions
  aperAttributesListing = "aper-attributes-list",
  aperAttributesCreate = "aper-attributes-create",
  aperGradingsListing = "aper-gradings-list",
  aperGradingsCreate = "aper-gradings-create",
  aperReportsListing = "aper-reports-list",
  aperReportsCreate = "aper-reports-create",
  aperReportsView = "aper-reports-show",
  aperSettings = "aper-settings",

  // Training and Development Program
  tdpDashboardList = "tdp-dashboard-list",
  tdpProgramsList = "tdp-programs-list",
  tdpProgramsCreateEmployees = "tdp-programs-create-employees",
  tdpMarkManualAttendance = "tdp-mark-manual-attendance",
  tdpProgramsEdit = "tdp-programs-edit",
  tdpProgramsDelete = "tdp-programs-delete",
  tdpCategoriesList = "tdp-categories-list",
  tdpCategoriesCreate = "tdp-categories-create",
  tdpCategoriesEdit = "tdp-categories-edit",
  tdpCategoriesDelete = "tdp-categories-delete",
  tdpTrainersList = "tdp-trainers-list",
  tdpTrainersCreate = "tdp-trainers-create",
  tdpTrainersEdit = "tdp-trainers-edit",
  tdpTrainersDelete = "tdp-trainers-delete",
  tdpFeedbackFormsList = "tdp-feedback-forms-list",
  tdpFeedbackFormsCreate = "tdp-feedback-forms-create",
  tdpFeedbackFormsEdit = "tdp-feedback-forms-edit",
  tdpFeedbackFormsDelete = "tdp-feedback-forms-delete",
  tdpCertificatesList = "tdp-certificates-list",
  
  viewtdp = "tdp-view",
  createtdpPrograms = "tdp-programs-create", // Keeping for backwards compat temporarily
  assigntdpFaculty = "tdp-assign-faculty",
  marktdpAttendance = "tdp-attendance-mark",
  submittdpFeedback = "tdp-feedback-submit",
  showAllInNominationListing = "show-all-in-nomination-listing",
  studentMigrationApplicationsListing = "eportal-migration-applications-list",

  // APER Types & Appraisals
  aperTypesListing = "aper-types-list",
  aperTypesCreate = "aper-types-create",
  aperAppraisalsListing = "aper-appraisals-list",
  aperAppraisalsCreate = "aper-appraisals-create",
  myAppraisal = "aper-appraisals-my-appraisal",

  // Eportal Registration Settings
  eportalRegistrationSettingsListing = "eportal-registration-settings-list",
  eportalRegistrationSettingsCreate = "eportal-registration-settings-create",
  eportalRegistrationSettingsEdit = "eportal-registration-settings-edit",
  eportalRegistrationSettingsDelete = "eportal-registration-settings-delete",

  aperDashboard = "aper-dashboard",
  studentQmsDashboard = "qms-my-queries",
  studentQmsCreateQuery = "qms-my-queries-create",
  qmsMyQueries = "qms-my-queries",
  qmsMyQueriesCreate = "qms-my-queries-create",
  qmsDashboard = "qms-dashboard",
  qmsServicesListing = "qms-services-listing",
  qmsServicesCreate = "qms-services-create",
  qmsCategoriesListing = "qms-categories-listing",
  qmsCategoriesCreate = "qms-categories-create",
  qmsPrioritiesListing = "qms-priorities-listing",
  qmsPrioritiesCreate = "qms-priorities-create",
  qmsStatusesListing = "qms-statuses-listing",
  qmsStatusesCreate = "qms-statuses-create",
  qmsRequestTypesListing = "qms-request-types-listing",
  qmsRequestTypesCreate = "qms-request-types-create",
  qmsWorkflowsListing = "qms-workflows-listing",
  qmsWorkflowsCreate = "qms-workflows-create",
  qmsQueriesListing = "qms-queries-listing",
  qmsQueriesView = "qms-queries-view",

  // Medical Insurance Form
  medicalInsuranceFormListing = "medical-insurance-form-list",
  medicalInsuranceFormAllListing = "medical-insurance-form-all-list",
  medicalInsuranceFormCreate = "medical-insurance-form-create",
  medicalInsuranceFormEdit = "medical-insurance-form-edit",
  medicalInsuranceFormDelete = "medical-insurance-form-delete",
  medicalInsuranceFormDownloadPDF = "medical-insurance-form-download-pdf",
  medicalInsuranceFormToggleDocument = "medical-insurance-form-toggle-document",

  // Elections (Student Affairs)
  viewElections = "elections-view",
  createElections = "elections-create",
  editElections = "elections-edit",
  deleteElections = "elections-delete",
  castVote = "elections-cast-vote",
  viewElectionPositions = "election-positions-view",
  createElectionPositions = "election-positions-create",
  editElectionPositions = "election-positions-edit",
  deleteElectionPositions = "election-positions-delete",
  viewElectionCandidates = "election-candidates-view",
  createElectionCandidates = "election-candidates-create",
  editElectionCandidates = "election-candidates-edit",
  deleteElectionCandidates = "election-candidates-delete",
  viewElectionSymbols = "election-symbols-view",
  createElectionSymbols = "election-symbols-create",
  editElectionSymbols = "election-symbols-edit",
  deleteElectionSymbols = "election-symbols-delete",
}

